// source: user-organization.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var mailbox_pb = require('./mailbox_pb.js');
goog.object.extend(proto, mailbox_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.users.ApiKeyAuditAction', null, global);
goog.exportSymbol('proto.users.ApiKeyAuditEntryView', null, global);
goog.exportSymbol('proto.users.ApiKeyScope', null, global);
goog.exportSymbol('proto.users.ApiKeyView', null, global);
goog.exportSymbol('proto.users.AppIntegrationRequest', null, global);
goog.exportSymbol('proto.users.AppIntegrationRequest.SettingsCase', null, global);
goog.exportSymbol('proto.users.AppIntegrationResponse', null, global);
goog.exportSymbol('proto.users.AppIntegrationResponse.SettingsCase', null, global);
goog.exportSymbol('proto.users.CreateApiKeyRequest', null, global);
goog.exportSymbol('proto.users.CreateApiKeyResponse', null, global);
goog.exportSymbol('proto.users.CreateWebhookEndpointRequest', null, global);
goog.exportSymbol('proto.users.CreateWebhookEndpointResponse', null, global);
goog.exportSymbol('proto.users.DailySchedule', null, global);
goog.exportSymbol('proto.users.InviteMemberRequest', null, global);
goog.exportSymbol('proto.users.ListApiKeyAuditRequest', null, global);
goog.exportSymbol('proto.users.ListApiKeyAuditResponse', null, global);
goog.exportSymbol('proto.users.ListApiKeysRequest', null, global);
goog.exportSymbol('proto.users.ListApiKeysResponse', null, global);
goog.exportSymbol('proto.users.ListWebhookEndpointAuditRequest', null, global);
goog.exportSymbol('proto.users.ListWebhookEndpointAuditResponse', null, global);
goog.exportSymbol('proto.users.ListWebhookEndpointsRequest', null, global);
goog.exportSymbol('proto.users.ListWebhookEndpointsResponse', null, global);
goog.exportSymbol('proto.users.OrganizationChecklistResponse', null, global);
goog.exportSymbol('proto.users.OrganizationChecklistTask', null, global);
goog.exportSymbol('proto.users.OrganizationChecklistTaskState', null, global);
goog.exportSymbol('proto.users.OrganizationFullResponse', null, global);
goog.exportSymbol('proto.users.OrganizationInviteResponse', null, global);
goog.exportSymbol('proto.users.OrganizationInviteStatus', null, global);
goog.exportSymbol('proto.users.OrganizationMemberInviteResponse', null, global);
goog.exportSymbol('proto.users.OrganizationMemberResponse', null, global);
goog.exportSymbol('proto.users.OrganizationMemberRole', null, global);
goog.exportSymbol('proto.users.OrganizationOnboardingConciergeDetails', null, global);
goog.exportSymbol('proto.users.OrganizationOnboardingDetails', null, global);
goog.exportSymbol('proto.users.OrganizationOnboardingDetails.DetailsCase', null, global);
goog.exportSymbol('proto.users.OrganizationOnboardingPublisherDetails', null, global);
goog.exportSymbol('proto.users.OrganizationRequest', null, global);
goog.exportSymbol('proto.users.OrganizationResponse', null, global);
goog.exportSymbol('proto.users.ReferralLinkData', null, global);
goog.exportSymbol('proto.users.RemoveMemberRequest', null, global);
goog.exportSymbol('proto.users.RotateApiKeyRequest', null, global);
goog.exportSymbol('proto.users.RotateApiKeyResponse', null, global);
goog.exportSymbol('proto.users.RotateWebhookSecretRequest', null, global);
goog.exportSymbol('proto.users.RotateWebhookSecretResponse', null, global);
goog.exportSymbol('proto.users.Schedule', null, global);
goog.exportSymbol('proto.users.ScheduleMember', null, global);
goog.exportSymbol('proto.users.ScheduleType', null, global);
goog.exportSymbol('proto.users.TrackingDomain', null, global);
goog.exportSymbol('proto.users.TrackingDomainDnsSettings', null, global);
goog.exportSymbol('proto.users.UnsubscribeContent', null, global);
goog.exportSymbol('proto.users.UpdateApiKeyRequest', null, global);
goog.exportSymbol('proto.users.UpdateMemberRequest', null, global);
goog.exportSymbol('proto.users.UpdateWebhookEndpointRequest', null, global);
goog.exportSymbol('proto.users.WebhookEndpointAuditAction', null, global);
goog.exportSymbol('proto.users.WebhookEndpointAuditEntryView', null, global);
goog.exportSymbol('proto.users.WebhookEndpointStatus', null, global);
goog.exportSymbol('proto.users.WebhookEndpointView', null, global);
goog.exportSymbol('proto.users.WebhookEventType', null, global);
goog.exportSymbol('proto.users.WorkspaceMemberRequest', null, global);
goog.exportSymbol('proto.users.WorkspaceMemberResponse', null, global);
goog.exportSymbol('proto.users.WorkspaceMemberShortResponse', null, global);
goog.exportSymbol('proto.users.WorkspaceNotificationChannel', null, global);
goog.exportSymbol('proto.users.WorkspaceNotificationChannel.SettingsCase', null, global);
goog.exportSymbol('proto.users.WorkspaceNotificationChannel.SlackIntegration', null, global);
goog.exportSymbol('proto.users.WorkspaceNotificationCountersResponse', null, global);
goog.exportSymbol('proto.users.WorkspaceNotificationRequest', null, global);
goog.exportSymbol('proto.users.WorkspaceNotificationResponse', null, global);
goog.exportSymbol('proto.users.WorkspaceRequest', null, global);
goog.exportSymbol('proto.users.WorkspaceResponse', null, global);
goog.exportSymbol('proto.users.WorkspaceResponseShort', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationRequest.displayName = 'proto.users.OrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationResponse.displayName = 'proto.users.OrganizationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationFullResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationFullResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationFullResponse.displayName = 'proto.users.OrganizationFullResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.WorkspaceRequest.repeatedFields_, null);
};
goog.inherits(proto.users.WorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceRequest.displayName = 'proto.users.WorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.WorkspaceResponse.repeatedFields_, null);
};
goog.inherits(proto.users.WorkspaceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceResponse.displayName = 'proto.users.WorkspaceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceResponseShort = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceResponseShort, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceResponseShort.displayName = 'proto.users.WorkspaceResponseShort';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.WorkspaceMemberRequest.repeatedFields_, null);
};
goog.inherits(proto.users.WorkspaceMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceMemberRequest.displayName = 'proto.users.WorkspaceMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.Schedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.Schedule.repeatedFields_, null);
};
goog.inherits(proto.users.Schedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.Schedule.displayName = 'proto.users.Schedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.DailySchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.DailySchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.DailySchedule.displayName = 'proto.users.DailySchedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ScheduleMember = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.ScheduleMember.repeatedFields_, null);
};
goog.inherits(proto.users.ScheduleMember, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ScheduleMember.displayName = 'proto.users.ScheduleMember';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.InviteMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.InviteMemberRequest.repeatedFields_, null);
};
goog.inherits(proto.users.InviteMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.InviteMemberRequest.displayName = 'proto.users.InviteMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.RemoveMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.RemoveMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.RemoveMemberRequest.displayName = 'proto.users.RemoveMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.UpdateMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.UpdateMemberRequest.repeatedFields_, null);
};
goog.inherits(proto.users.UpdateMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.UpdateMemberRequest.displayName = 'proto.users.UpdateMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.OrganizationMemberResponse.repeatedFields_, null);
};
goog.inherits(proto.users.OrganizationMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationMemberResponse.displayName = 'proto.users.OrganizationMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.OrganizationInviteResponse.repeatedFields_, null);
};
goog.inherits(proto.users.OrganizationInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationInviteResponse.displayName = 'proto.users.OrganizationInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationOnboardingDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.users.OrganizationOnboardingDetails.oneofGroups_);
};
goog.inherits(proto.users.OrganizationOnboardingDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationOnboardingDetails.displayName = 'proto.users.OrganizationOnboardingDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationOnboardingConciergeDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationOnboardingConciergeDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationOnboardingConciergeDetails.displayName = 'proto.users.OrganizationOnboardingConciergeDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationOnboardingPublisherDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationOnboardingPublisherDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationOnboardingPublisherDetails.displayName = 'proto.users.OrganizationOnboardingPublisherDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceMemberResponse.displayName = 'proto.users.WorkspaceMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceMemberShortResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceMemberShortResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceMemberShortResponse.displayName = 'proto.users.WorkspaceMemberShortResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationMemberInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationMemberInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationMemberInviteResponse.displayName = 'proto.users.OrganizationMemberInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationChecklistTaskState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.OrganizationChecklistTaskState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationChecklistTaskState.displayName = 'proto.users.OrganizationChecklistTaskState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.OrganizationChecklistResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.OrganizationChecklistResponse.repeatedFields_, null);
};
goog.inherits(proto.users.OrganizationChecklistResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.OrganizationChecklistResponse.displayName = 'proto.users.OrganizationChecklistResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.AppIntegrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.AppIntegrationRequest.repeatedFields_, proto.users.AppIntegrationRequest.oneofGroups_);
};
goog.inherits(proto.users.AppIntegrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.AppIntegrationRequest.displayName = 'proto.users.AppIntegrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.AppIntegrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.AppIntegrationResponse.repeatedFields_, proto.users.AppIntegrationResponse.oneofGroups_);
};
goog.inherits(proto.users.AppIntegrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.AppIntegrationResponse.displayName = 'proto.users.AppIntegrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.UnsubscribeContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.UnsubscribeContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.UnsubscribeContent.displayName = 'proto.users.UnsubscribeContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.TrackingDomainDnsSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.TrackingDomainDnsSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.TrackingDomainDnsSettings.displayName = 'proto.users.TrackingDomainDnsSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.TrackingDomain = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.TrackingDomain, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.TrackingDomain.displayName = 'proto.users.TrackingDomain';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ReferralLinkData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.ReferralLinkData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ReferralLinkData.displayName = 'proto.users.ReferralLinkData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceNotificationRequest.displayName = 'proto.users.WorkspaceNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceNotificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceNotificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceNotificationResponse.displayName = 'proto.users.WorkspaceNotificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceNotificationCountersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceNotificationCountersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceNotificationCountersResponse.displayName = 'proto.users.WorkspaceNotificationCountersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceNotificationChannel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.WorkspaceNotificationChannel.repeatedFields_, proto.users.WorkspaceNotificationChannel.oneofGroups_);
};
goog.inherits(proto.users.WorkspaceNotificationChannel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceNotificationChannel.displayName = 'proto.users.WorkspaceNotificationChannel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WorkspaceNotificationChannel.SlackIntegration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WorkspaceNotificationChannel.SlackIntegration.displayName = 'proto.users.WorkspaceNotificationChannel.SlackIntegration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ApiKeyView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.ApiKeyView.repeatedFields_, null);
};
goog.inherits(proto.users.ApiKeyView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ApiKeyView.displayName = 'proto.users.ApiKeyView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.CreateApiKeyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.CreateApiKeyRequest.repeatedFields_, null);
};
goog.inherits(proto.users.CreateApiKeyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.CreateApiKeyRequest.displayName = 'proto.users.CreateApiKeyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.CreateApiKeyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.CreateApiKeyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.CreateApiKeyResponse.displayName = 'proto.users.CreateApiKeyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListApiKeysRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.ListApiKeysRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListApiKeysRequest.displayName = 'proto.users.ListApiKeysRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListApiKeysResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.ListApiKeysResponse.repeatedFields_, null);
};
goog.inherits(proto.users.ListApiKeysResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListApiKeysResponse.displayName = 'proto.users.ListApiKeysResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.UpdateApiKeyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.UpdateApiKeyRequest.repeatedFields_, null);
};
goog.inherits(proto.users.UpdateApiKeyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.UpdateApiKeyRequest.displayName = 'proto.users.UpdateApiKeyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.RotateApiKeyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.RotateApiKeyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.RotateApiKeyRequest.displayName = 'proto.users.RotateApiKeyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.RotateApiKeyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.RotateApiKeyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.RotateApiKeyResponse.displayName = 'proto.users.RotateApiKeyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ApiKeyAuditEntryView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.ApiKeyAuditEntryView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ApiKeyAuditEntryView.displayName = 'proto.users.ApiKeyAuditEntryView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListApiKeyAuditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.ListApiKeyAuditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListApiKeyAuditRequest.displayName = 'proto.users.ListApiKeyAuditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListApiKeyAuditResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.ListApiKeyAuditResponse.repeatedFields_, null);
};
goog.inherits(proto.users.ListApiKeyAuditResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListApiKeyAuditResponse.displayName = 'proto.users.ListApiKeyAuditResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WebhookEndpointView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.WebhookEndpointView.repeatedFields_, null);
};
goog.inherits(proto.users.WebhookEndpointView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WebhookEndpointView.displayName = 'proto.users.WebhookEndpointView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.CreateWebhookEndpointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.CreateWebhookEndpointRequest.repeatedFields_, null);
};
goog.inherits(proto.users.CreateWebhookEndpointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.CreateWebhookEndpointRequest.displayName = 'proto.users.CreateWebhookEndpointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.CreateWebhookEndpointResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.CreateWebhookEndpointResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.CreateWebhookEndpointResponse.displayName = 'proto.users.CreateWebhookEndpointResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListWebhookEndpointsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.ListWebhookEndpointsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListWebhookEndpointsRequest.displayName = 'proto.users.ListWebhookEndpointsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListWebhookEndpointsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.ListWebhookEndpointsResponse.repeatedFields_, null);
};
goog.inherits(proto.users.ListWebhookEndpointsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListWebhookEndpointsResponse.displayName = 'proto.users.ListWebhookEndpointsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.UpdateWebhookEndpointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.UpdateWebhookEndpointRequest.repeatedFields_, null);
};
goog.inherits(proto.users.UpdateWebhookEndpointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.UpdateWebhookEndpointRequest.displayName = 'proto.users.UpdateWebhookEndpointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.RotateWebhookSecretRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.RotateWebhookSecretRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.RotateWebhookSecretRequest.displayName = 'proto.users.RotateWebhookSecretRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.RotateWebhookSecretResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.RotateWebhookSecretResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.RotateWebhookSecretResponse.displayName = 'proto.users.RotateWebhookSecretResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.WebhookEndpointAuditEntryView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.WebhookEndpointAuditEntryView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.WebhookEndpointAuditEntryView.displayName = 'proto.users.WebhookEndpointAuditEntryView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListWebhookEndpointAuditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.users.ListWebhookEndpointAuditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListWebhookEndpointAuditRequest.displayName = 'proto.users.ListWebhookEndpointAuditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.users.ListWebhookEndpointAuditResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.users.ListWebhookEndpointAuditResponse.repeatedFields_, null);
};
goog.inherits(proto.users.ListWebhookEndpointAuditResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.users.ListWebhookEndpointAuditResponse.displayName = 'proto.users.ListWebhookEndpointAuditResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationRequest}
 */
proto.users.OrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationRequest;
  return proto.users.OrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationRequest}
 */
proto.users.OrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.users.OrganizationRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationRequest} returns this
 */
proto.users.OrganizationRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logo_url = 2;
 * @return {string}
 */
proto.users.OrganizationRequest.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationRequest} returns this
 */
proto.users.OrganizationRequest.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationResponse}
 */
proto.users.OrganizationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationResponse;
  return proto.users.OrganizationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationResponse}
 */
proto.users.OrganizationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.users.OrganizationResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationResponse} returns this
 */
proto.users.OrganizationResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logo_url = 2;
 * @return {string}
 */
proto.users.OrganizationResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationResponse} returns this
 */
proto.users.OrganizationResponse.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationFullResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationFullResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationFullResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationFullResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
membersNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
workspacesNumber: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationFullResponse}
 */
proto.users.OrganizationFullResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationFullResponse;
  return proto.users.OrganizationFullResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationFullResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationFullResponse}
 */
proto.users.OrganizationFullResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMembersNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkspacesNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationFullResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationFullResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationFullResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationFullResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMembersNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getWorkspacesNumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.users.OrganizationFullResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationFullResponse} returns this
 */
proto.users.OrganizationFullResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logo_url = 2;
 * @return {string}
 */
proto.users.OrganizationFullResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationFullResponse} returns this
 */
proto.users.OrganizationFullResponse.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 members_number = 3;
 * @return {number}
 */
proto.users.OrganizationFullResponse.prototype.getMembersNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationFullResponse} returns this
 */
proto.users.OrganizationFullResponse.prototype.setMembersNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 workspaces_number = 4;
 * @return {number}
 */
proto.users.OrganizationFullResponse.prototype.getWorkspacesNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationFullResponse} returns this
 */
proto.users.OrganizationFullResponse.prototype.setWorkspacesNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.WorkspaceRequest.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
accountIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
userIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
domain: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceRequest}
 */
proto.users.WorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceRequest;
  return proto.users.WorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceRequest}
 */
proto.users.WorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAccountIds(values[i]);
      }
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUserIds(values[i]);
      }
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      4,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      5,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WorkspaceRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.users.WorkspaceRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.users.WorkspaceRequest.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int64 account_ids = 4;
 * @return {!Array<number>}
 */
proto.users.WorkspaceRequest.prototype.getAccountIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.setAccountIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.addAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.clearAccountIdsList = function() {
  return this.setAccountIdsList([]);
};


/**
 * repeated int64 user_ids = 5;
 * @return {!Array<number>}
 */
proto.users.WorkspaceRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * optional string domain = 6;
 * @return {string}
 */
proto.users.WorkspaceRequest.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceRequest} returns this
 */
proto.users.WorkspaceRequest.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.WorkspaceResponse.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
membersCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
mailboxesCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
campaignsCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    mailbox_pb.InboxAccountsPreset.toObject, includeInstance),
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.users.WorkspaceMemberShortResponse.toObject, includeInstance),
favorite: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
domain: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceResponse}
 */
proto.users.WorkspaceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceResponse;
  return proto.users.WorkspaceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceResponse}
 */
proto.users.WorkspaceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMembersCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMailboxesCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCampaignsCount(value);
      break;
    case 7:
      var value = new mailbox_pb.InboxAccountsPreset;
      reader.readMessage(value,mailbox_pb.InboxAccountsPreset.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 8:
      var value = new proto.users.WorkspaceMemberShortResponse;
      reader.readMessage(value,proto.users.WorkspaceMemberShortResponse.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFavorite(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMembersCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMailboxesCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCampaignsCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      mailbox_pb.InboxAccountsPreset.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.users.WorkspaceMemberShortResponse.serializeBinaryToWriter
    );
  }
  f = message.getFavorite();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WorkspaceResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.users.WorkspaceResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.users.WorkspaceResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 members_count = 4;
 * @return {number}
 */
proto.users.WorkspaceResponse.prototype.getMembersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setMembersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 mailboxes_count = 5;
 * @return {number}
 */
proto.users.WorkspaceResponse.prototype.getMailboxesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setMailboxesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 campaigns_count = 6;
 * @return {number}
 */
proto.users.WorkspaceResponse.prototype.getCampaignsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setCampaignsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated inbox.InboxAccountsPreset accounts = 7;
 * @return {!Array<!proto.inbox.InboxAccountsPreset>}
 */
proto.users.WorkspaceResponse.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.inbox.InboxAccountsPreset>} */ (
    jspb.Message.getRepeatedWrapperField(this, mailbox_pb.InboxAccountsPreset, 7));
};


/**
 * @param {!Array<!proto.inbox.InboxAccountsPreset>} value
 * @return {!proto.users.WorkspaceResponse} returns this
*/
proto.users.WorkspaceResponse.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.inbox.InboxAccountsPreset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.inbox.InboxAccountsPreset}
 */
proto.users.WorkspaceResponse.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.inbox.InboxAccountsPreset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * repeated WorkspaceMemberShortResponse members = 8;
 * @return {!Array<!proto.users.WorkspaceMemberShortResponse>}
 */
proto.users.WorkspaceResponse.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.users.WorkspaceMemberShortResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.WorkspaceMemberShortResponse, 8));
};


/**
 * @param {!Array<!proto.users.WorkspaceMemberShortResponse>} value
 * @return {!proto.users.WorkspaceResponse} returns this
*/
proto.users.WorkspaceResponse.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.users.WorkspaceMemberShortResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.WorkspaceMemberShortResponse}
 */
proto.users.WorkspaceResponse.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.users.WorkspaceMemberShortResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional bool favorite = 9;
 * @return {boolean}
 */
proto.users.WorkspaceResponse.prototype.getFavorite = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setFavorite = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string domain = 10;
 * @return {string}
 */
proto.users.WorkspaceResponse.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceResponse} returns this
 */
proto.users.WorkspaceResponse.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceResponseShort.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceResponseShort.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceResponseShort} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceResponseShort.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
membersCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
favorite: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceResponseShort}
 */
proto.users.WorkspaceResponseShort.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceResponseShort;
  return proto.users.WorkspaceResponseShort.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceResponseShort} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceResponseShort}
 */
proto.users.WorkspaceResponseShort.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMembersCount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFavorite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceResponseShort.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceResponseShort.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceResponseShort} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceResponseShort.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMembersCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFavorite();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WorkspaceResponseShort.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceResponseShort} returns this
 */
proto.users.WorkspaceResponseShort.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.users.WorkspaceResponseShort.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceResponseShort} returns this
 */
proto.users.WorkspaceResponseShort.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.users.WorkspaceResponseShort.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceResponseShort} returns this
 */
proto.users.WorkspaceResponseShort.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 members_count = 4;
 * @return {number}
 */
proto.users.WorkspaceResponseShort.prototype.getMembersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceResponseShort} returns this
 */
proto.users.WorkspaceResponseShort.prototype.setMembersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool favorite = 5;
 * @return {boolean}
 */
proto.users.WorkspaceResponseShort.prototype.getFavorite = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.WorkspaceResponseShort} returns this
 */
proto.users.WorkspaceResponseShort.prototype.setFavorite = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.WorkspaceMemberRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
userIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceMemberRequest}
 */
proto.users.WorkspaceMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceMemberRequest;
  return proto.users.WorkspaceMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceMemberRequest}
 */
proto.users.WorkspaceMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUserIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.users.WorkspaceMemberRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceMemberRequest} returns this
 */
proto.users.WorkspaceMemberRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int64 user_ids = 3;
 * @return {!Array<number>}
 */
proto.users.WorkspaceMemberRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.WorkspaceMemberRequest} returns this
 */
proto.users.WorkspaceMemberRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.WorkspaceMemberRequest} returns this
 */
proto.users.WorkspaceMemberRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WorkspaceMemberRequest} returns this
 */
proto.users.WorkspaceMemberRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.Schedule.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.Schedule.prototype.toObject = function(opt_includeInstance) {
  return proto.users.Schedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.Schedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.Schedule.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, 0),
timezoneId: jspb.Message.getFieldWithDefault(msg, 4, 0),
timezoneValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
dayList: jspb.Message.toObjectList(msg.getDayList(),
    proto.users.DailySchedule.toObject, includeInstance),
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
optionalTotalItems: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.Schedule}
 */
proto.users.Schedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.Schedule;
  return proto.users.Schedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.Schedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.Schedule}
 */
proto.users.Schedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {!proto.users.ScheduleType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimezoneId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezoneValue(value);
      break;
    case 6:
      var value = new proto.users.DailySchedule;
      reader.readMessage(value,proto.users.DailySchedule.deserializeBinaryFromReader);
      msg.addDay(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOptionalTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.Schedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.Schedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.Schedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.Schedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTimezoneId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTimezoneValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.users.DailySchedule.serializeBinaryToWriter
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getOptionalTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.Schedule.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.users.Schedule.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ScheduleType type = 3;
 * @return {!proto.users.ScheduleType}
 */
proto.users.Schedule.prototype.getType = function() {
  return /** @type {!proto.users.ScheduleType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.users.ScheduleType} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 timezone_id = 4;
 * @return {number}
 */
proto.users.Schedule.prototype.getTimezoneId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setTimezoneId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string timezone_value = 5;
 * @return {string}
 */
proto.users.Schedule.prototype.getTimezoneValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setTimezoneValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated DailySchedule day = 6;
 * @return {!Array<!proto.users.DailySchedule>}
 */
proto.users.Schedule.prototype.getDayList = function() {
  return /** @type{!Array<!proto.users.DailySchedule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.DailySchedule, 6));
};


/**
 * @param {!Array<!proto.users.DailySchedule>} value
 * @return {!proto.users.Schedule} returns this
*/
proto.users.Schedule.prototype.setDayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.users.DailySchedule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.DailySchedule}
 */
proto.users.Schedule.prototype.addDay = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.users.DailySchedule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.clearDayList = function() {
  return this.setDayList([]);
};


/**
 * optional bool deleted = 7;
 * @return {boolean}
 */
proto.users.Schedule.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int32 optional_total_items = 8;
 * @return {number}
 */
proto.users.Schedule.prototype.getOptionalTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.Schedule} returns this
 */
proto.users.Schedule.prototype.setOptionalTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.DailySchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.users.DailySchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.DailySchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.DailySchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
day: jspb.Message.getFieldWithDefault(msg, 1, 0),
includeDay: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
timeFrom: jspb.Message.getFieldWithDefault(msg, 3, ""),
timeTo: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.DailySchedule}
 */
proto.users.DailySchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.DailySchedule;
  return proto.users.DailySchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.DailySchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.DailySchedule}
 */
proto.users.DailySchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDay(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDay(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeFrom(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.DailySchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.DailySchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.DailySchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.DailySchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDay();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIncludeDay();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTimeFrom();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeTo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 day = 1;
 * @return {number}
 */
proto.users.DailySchedule.prototype.getDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.DailySchedule} returns this
 */
proto.users.DailySchedule.prototype.setDay = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool include_day = 2;
 * @return {boolean}
 */
proto.users.DailySchedule.prototype.getIncludeDay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.DailySchedule} returns this
 */
proto.users.DailySchedule.prototype.setIncludeDay = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string time_from = 3;
 * @return {string}
 */
proto.users.DailySchedule.prototype.getTimeFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.DailySchedule} returns this
 */
proto.users.DailySchedule.prototype.setTimeFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string time_to = 4;
 * @return {string}
 */
proto.users.DailySchedule.prototype.getTimeTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.DailySchedule} returns this
 */
proto.users.DailySchedule.prototype.setTimeTo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.ScheduleMember.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ScheduleMember.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ScheduleMember.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ScheduleMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ScheduleMember.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
scheduleIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ScheduleMember}
 */
proto.users.ScheduleMember.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ScheduleMember;
  return proto.users.ScheduleMember.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ScheduleMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ScheduleMember}
 */
proto.users.ScheduleMember.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addScheduleIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ScheduleMember.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ScheduleMember.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ScheduleMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ScheduleMember.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getScheduleIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.users.ScheduleMember.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ScheduleMember} returns this
 */
proto.users.ScheduleMember.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int64 schedule_ids = 2;
 * @return {!Array<number>}
 */
proto.users.ScheduleMember.prototype.getScheduleIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.ScheduleMember} returns this
 */
proto.users.ScheduleMember.prototype.setScheduleIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.ScheduleMember} returns this
 */
proto.users.ScheduleMember.prototype.addScheduleIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ScheduleMember} returns this
 */
proto.users.ScheduleMember.prototype.clearScheduleIdsList = function() {
  return this.setScheduleIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.InviteMemberRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.InviteMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.InviteMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.InviteMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.InviteMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
role: jspb.Message.getFieldWithDefault(msg, 1, 0),
emailsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.InviteMemberRequest}
 */
proto.users.InviteMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.InviteMemberRequest;
  return proto.users.InviteMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.InviteMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.InviteMemberRequest}
 */
proto.users.InviteMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.users.OrganizationMemberRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmails(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.InviteMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.InviteMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.InviteMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.InviteMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional OrganizationMemberRole role = 1;
 * @return {!proto.users.OrganizationMemberRole}
 */
proto.users.InviteMemberRequest.prototype.getRole = function() {
  return /** @type {!proto.users.OrganizationMemberRole} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.users.OrganizationMemberRole} value
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string emails = 2;
 * @return {!Array<string>}
 */
proto.users.InviteMemberRequest.prototype.getEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.setEmailsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.addEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.clearEmailsList = function() {
  return this.setEmailsList([]);
};


/**
 * repeated int64 workspace_ids = 3;
 * @return {!Array<number>}
 */
proto.users.InviteMemberRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.InviteMemberRequest} returns this
 */
proto.users.InviteMemberRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.RemoveMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.RemoveMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.RemoveMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RemoveMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
optionalUserIdForTransferData: jspb.Message.getFieldWithDefault(msg, 2, 0),
removeData: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.RemoveMemberRequest}
 */
proto.users.RemoveMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.RemoveMemberRequest;
  return proto.users.RemoveMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.RemoveMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.RemoveMemberRequest}
 */
proto.users.RemoveMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalUserIdForTransferData(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoveData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.RemoveMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.RemoveMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.RemoveMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RemoveMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOptionalUserIdForTransferData();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRemoveData();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.RemoveMemberRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.RemoveMemberRequest} returns this
 */
proto.users.RemoveMemberRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 optional_user_id_for_transfer_data = 2;
 * @return {number}
 */
proto.users.RemoveMemberRequest.prototype.getOptionalUserIdForTransferData = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.RemoveMemberRequest} returns this
 */
proto.users.RemoveMemberRequest.prototype.setOptionalUserIdForTransferData = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool remove_data = 3;
 * @return {boolean}
 */
proto.users.RemoveMemberRequest.prototype.getRemoveData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.RemoveMemberRequest} returns this
 */
proto.users.RemoveMemberRequest.prototype.setRemoveData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.UpdateMemberRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.UpdateMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.UpdateMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.UpdateMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UpdateMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
role: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.UpdateMemberRequest}
 */
proto.users.UpdateMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.UpdateMemberRequest;
  return proto.users.UpdateMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.UpdateMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.UpdateMemberRequest}
 */
proto.users.UpdateMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.users.OrganizationMemberRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.UpdateMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.UpdateMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.UpdateMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UpdateMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.UpdateMemberRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.UpdateMemberRequest} returns this
 */
proto.users.UpdateMemberRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OrganizationMemberRole role = 2;
 * @return {!proto.users.OrganizationMemberRole}
 */
proto.users.UpdateMemberRequest.prototype.getRole = function() {
  return /** @type {!proto.users.OrganizationMemberRole} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.users.OrganizationMemberRole} value
 * @return {!proto.users.UpdateMemberRequest} returns this
 */
proto.users.UpdateMemberRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated int64 workspace_ids = 3;
 * @return {!Array<number>}
 */
proto.users.UpdateMemberRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.UpdateMemberRequest} returns this
 */
proto.users.UpdateMemberRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.UpdateMemberRequest} returns this
 */
proto.users.UpdateMemberRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.UpdateMemberRequest} returns this
 */
proto.users.UpdateMemberRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.OrganizationMemberResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
fullName: jspb.Message.getFieldWithDefault(msg, 3, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
rolesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
email: jspb.Message.getFieldWithDefault(msg, 6, ""),
workspacesNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
invitedAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
invitedBy: jspb.Message.getFieldWithDefault(msg, 9, ""),
totalItems: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationMemberResponse}
 */
proto.users.OrganizationMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationMemberResponse;
  return proto.users.OrganizationMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationMemberResponse}
 */
proto.users.OrganizationMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.users.OrganizationMemberRole>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkspacesNumber(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvitedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvitedBy(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWorkspacesNumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getInvitedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getInvitedBy();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.OrganizationMemberResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 user_id = 2;
 * @return {number}
 */
proto.users.OrganizationMemberResponse.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string full_name = 3;
 * @return {string}
 */
proto.users.OrganizationMemberResponse.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string logo_url = 4;
 * @return {string}
 */
proto.users.OrganizationMemberResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated OrganizationMemberRole roles = 5;
 * @return {!Array<!proto.users.OrganizationMemberRole>}
 */
proto.users.OrganizationMemberResponse.prototype.getRolesList = function() {
  return /** @type {!Array<!proto.users.OrganizationMemberRole>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.users.OrganizationMemberRole>} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.users.OrganizationMemberRole} value
 * @param {number=} opt_index
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};


/**
 * optional string email = 6;
 * @return {string}
 */
proto.users.OrganizationMemberResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 workspaces_number = 7;
 * @return {number}
 */
proto.users.OrganizationMemberResponse.prototype.getWorkspacesNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setWorkspacesNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 invited_at = 8;
 * @return {number}
 */
proto.users.OrganizationMemberResponse.prototype.getInvitedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setInvitedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string invited_by = 9;
 * @return {string}
 */
proto.users.OrganizationMemberResponse.prototype.getInvitedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setInvitedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 total_items = 10;
 * @return {number}
 */
proto.users.OrganizationMemberResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationMemberResponse} returns this
 */
proto.users.OrganizationMemberResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.OrganizationInviteResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
role: jspb.Message.getFieldWithDefault(msg, 4, 0),
sentAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
sentBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
totalItems: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationInviteResponse}
 */
proto.users.OrganizationInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationInviteResponse;
  return proto.users.OrganizationInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationInviteResponse}
 */
proto.users.OrganizationInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {!proto.users.OrganizationInviteStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {!proto.users.OrganizationMemberRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSentAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSentBy(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSentAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSentBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      7,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.OrganizationInviteResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.users.OrganizationInviteResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional OrganizationInviteStatus status = 3;
 * @return {!proto.users.OrganizationInviteStatus}
 */
proto.users.OrganizationInviteResponse.prototype.getStatus = function() {
  return /** @type {!proto.users.OrganizationInviteStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.users.OrganizationInviteStatus} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional OrganizationMemberRole role = 4;
 * @return {!proto.users.OrganizationMemberRole}
 */
proto.users.OrganizationInviteResponse.prototype.getRole = function() {
  return /** @type {!proto.users.OrganizationMemberRole} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.users.OrganizationMemberRole} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 sent_at = 5;
 * @return {number}
 */
proto.users.OrganizationInviteResponse.prototype.getSentAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setSentAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string sent_by = 6;
 * @return {string}
 */
proto.users.OrganizationInviteResponse.prototype.getSentBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setSentBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated int64 workspace_ids = 7;
 * @return {!Array<number>}
 */
proto.users.OrganizationInviteResponse.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};


/**
 * optional int32 total_items = 8;
 * @return {number}
 */
proto.users.OrganizationInviteResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationInviteResponse} returns this
 */
proto.users.OrganizationInviteResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.users.OrganizationOnboardingDetails.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.users.OrganizationOnboardingDetails.DetailsCase = {
  DETAILS_NOT_SET: 0,
  CONCIERGE: 4,
  PUBLISHER: 5
};

/**
 * @return {proto.users.OrganizationOnboardingDetails.DetailsCase}
 */
proto.users.OrganizationOnboardingDetails.prototype.getDetailsCase = function() {
  return /** @type {proto.users.OrganizationOnboardingDetails.DetailsCase} */(jspb.Message.computeOneofCase(this, proto.users.OrganizationOnboardingDetails.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationOnboardingDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationOnboardingDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationOnboardingDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationOnboardingDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
realm: jspb.Message.getFieldWithDefault(msg, 2, 0),
completed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
concierge: (f = msg.getConcierge()) && proto.users.OrganizationOnboardingConciergeDetails.toObject(includeInstance, f),
publisher: (f = msg.getPublisher()) && proto.users.OrganizationOnboardingPublisherDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationOnboardingDetails}
 */
proto.users.OrganizationOnboardingDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationOnboardingDetails;
  return proto.users.OrganizationOnboardingDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationOnboardingDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationOnboardingDetails}
 */
proto.users.OrganizationOnboardingDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.common.RealmType} */ (reader.readEnum());
      msg.setRealm(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 4:
      var value = new proto.users.OrganizationOnboardingConciergeDetails;
      reader.readMessage(value,proto.users.OrganizationOnboardingConciergeDetails.deserializeBinaryFromReader);
      msg.setConcierge(value);
      break;
    case 5:
      var value = new proto.users.OrganizationOnboardingPublisherDetails;
      reader.readMessage(value,proto.users.OrganizationOnboardingPublisherDetails.deserializeBinaryFromReader);
      msg.setPublisher(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationOnboardingDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationOnboardingDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationOnboardingDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationOnboardingDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRealm();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getConcierge();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.users.OrganizationOnboardingConciergeDetails.serializeBinaryToWriter
    );
  }
  f = message.getPublisher();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.users.OrganizationOnboardingPublisherDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.OrganizationOnboardingDetails.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
 */
proto.users.OrganizationOnboardingDetails.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.RealmType realm = 2;
 * @return {!proto.common.RealmType}
 */
proto.users.OrganizationOnboardingDetails.prototype.getRealm = function() {
  return /** @type {!proto.common.RealmType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.RealmType} value
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
 */
proto.users.OrganizationOnboardingDetails.prototype.setRealm = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool completed = 3;
 * @return {boolean}
 */
proto.users.OrganizationOnboardingDetails.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
 */
proto.users.OrganizationOnboardingDetails.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional OrganizationOnboardingConciergeDetails concierge = 4;
 * @return {?proto.users.OrganizationOnboardingConciergeDetails}
 */
proto.users.OrganizationOnboardingDetails.prototype.getConcierge = function() {
  return /** @type{?proto.users.OrganizationOnboardingConciergeDetails} */ (
    jspb.Message.getWrapperField(this, proto.users.OrganizationOnboardingConciergeDetails, 4));
};


/**
 * @param {?proto.users.OrganizationOnboardingConciergeDetails|undefined} value
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
*/
proto.users.OrganizationOnboardingDetails.prototype.setConcierge = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.users.OrganizationOnboardingDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
 */
proto.users.OrganizationOnboardingDetails.prototype.clearConcierge = function() {
  return this.setConcierge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.OrganizationOnboardingDetails.prototype.hasConcierge = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional OrganizationOnboardingPublisherDetails publisher = 5;
 * @return {?proto.users.OrganizationOnboardingPublisherDetails}
 */
proto.users.OrganizationOnboardingDetails.prototype.getPublisher = function() {
  return /** @type{?proto.users.OrganizationOnboardingPublisherDetails} */ (
    jspb.Message.getWrapperField(this, proto.users.OrganizationOnboardingPublisherDetails, 5));
};


/**
 * @param {?proto.users.OrganizationOnboardingPublisherDetails|undefined} value
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
*/
proto.users.OrganizationOnboardingDetails.prototype.setPublisher = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.users.OrganizationOnboardingDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.OrganizationOnboardingDetails} returns this
 */
proto.users.OrganizationOnboardingDetails.prototype.clearPublisher = function() {
  return this.setPublisher(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.OrganizationOnboardingDetails.prototype.hasPublisher = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationOnboardingConciergeDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationOnboardingConciergeDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationOnboardingConciergeDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationOnboardingConciergeDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
referralSource: jspb.Message.getFieldWithDefault(msg, 1, ""),
followUpQuestion: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationOnboardingConciergeDetails}
 */
proto.users.OrganizationOnboardingConciergeDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationOnboardingConciergeDetails;
  return proto.users.OrganizationOnboardingConciergeDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationOnboardingConciergeDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationOnboardingConciergeDetails}
 */
proto.users.OrganizationOnboardingConciergeDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferralSource(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFollowUpQuestion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationOnboardingConciergeDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationOnboardingConciergeDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationOnboardingConciergeDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationOnboardingConciergeDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferralSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFollowUpQuestion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string referral_source = 1;
 * @return {string}
 */
proto.users.OrganizationOnboardingConciergeDetails.prototype.getReferralSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationOnboardingConciergeDetails} returns this
 */
proto.users.OrganizationOnboardingConciergeDetails.prototype.setReferralSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string follow_up_question = 2;
 * @return {string}
 */
proto.users.OrganizationOnboardingConciergeDetails.prototype.getFollowUpQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationOnboardingConciergeDetails} returns this
 */
proto.users.OrganizationOnboardingConciergeDetails.prototype.setFollowUpQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationOnboardingPublisherDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationOnboardingPublisherDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationOnboardingPublisherDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
brandManagementType: jspb.Message.getFieldWithDefault(msg, 1, ""),
linkedIn: jspb.Message.getFieldWithDefault(msg, 2, ""),
referralSource: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationOnboardingPublisherDetails}
 */
proto.users.OrganizationOnboardingPublisherDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationOnboardingPublisherDetails;
  return proto.users.OrganizationOnboardingPublisherDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationOnboardingPublisherDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationOnboardingPublisherDetails}
 */
proto.users.OrganizationOnboardingPublisherDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandManagementType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkedIn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferralSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationOnboardingPublisherDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationOnboardingPublisherDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationOnboardingPublisherDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandManagementType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLinkedIn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReferralSource();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string brand_management_type = 1;
 * @return {string}
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.getBrandManagementType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationOnboardingPublisherDetails} returns this
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.setBrandManagementType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string linked_in = 2;
 * @return {string}
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.getLinkedIn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationOnboardingPublisherDetails} returns this
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.setLinkedIn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string referral_source = 3;
 * @return {string}
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.getReferralSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationOnboardingPublisherDetails} returns this
 */
proto.users.OrganizationOnboardingPublisherDetails.prototype.setReferralSource = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
fullName: jspb.Message.getFieldWithDefault(msg, 3, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
email: jspb.Message.getFieldWithDefault(msg, 5, ""),
totalItems: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceMemberResponse}
 */
proto.users.WorkspaceMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceMemberResponse;
  return proto.users.WorkspaceMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceMemberResponse}
 */
proto.users.WorkspaceMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WorkspaceMemberResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceMemberResponse} returns this
 */
proto.users.WorkspaceMemberResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 user_id = 2;
 * @return {number}
 */
proto.users.WorkspaceMemberResponse.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceMemberResponse} returns this
 */
proto.users.WorkspaceMemberResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string full_name = 3;
 * @return {string}
 */
proto.users.WorkspaceMemberResponse.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceMemberResponse} returns this
 */
proto.users.WorkspaceMemberResponse.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string logo_url = 4;
 * @return {string}
 */
proto.users.WorkspaceMemberResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceMemberResponse} returns this
 */
proto.users.WorkspaceMemberResponse.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.users.WorkspaceMemberResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceMemberResponse} returns this
 */
proto.users.WorkspaceMemberResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 total_items = 6;
 * @return {number}
 */
proto.users.WorkspaceMemberResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceMemberResponse} returns this
 */
proto.users.WorkspaceMemberResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceMemberShortResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceMemberShortResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceMemberShortResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceMemberShortResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fullName: jspb.Message.getFieldWithDefault(msg, 2, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
isMe: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceMemberShortResponse}
 */
proto.users.WorkspaceMemberShortResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceMemberShortResponse;
  return proto.users.WorkspaceMemberShortResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceMemberShortResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceMemberShortResponse}
 */
proto.users.WorkspaceMemberShortResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceMemberShortResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceMemberShortResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceMemberShortResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceMemberShortResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsMe();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.users.WorkspaceMemberShortResponse.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceMemberShortResponse} returns this
 */
proto.users.WorkspaceMemberShortResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string full_name = 2;
 * @return {string}
 */
proto.users.WorkspaceMemberShortResponse.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceMemberShortResponse} returns this
 */
proto.users.WorkspaceMemberShortResponse.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.users.WorkspaceMemberShortResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceMemberShortResponse} returns this
 */
proto.users.WorkspaceMemberShortResponse.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_me = 4;
 * @return {boolean}
 */
proto.users.WorkspaceMemberShortResponse.prototype.getIsMe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.WorkspaceMemberShortResponse} returns this
 */
proto.users.WorkspaceMemberShortResponse.prototype.setIsMe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationMemberInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationMemberInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationMemberInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationMemberInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
organizationTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
organizationLogo: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationMemberInviteResponse}
 */
proto.users.OrganizationMemberInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationMemberInviteResponse;
  return proto.users.OrganizationMemberInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationMemberInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationMemberInviteResponse}
 */
proto.users.OrganizationMemberInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationLogo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationMemberInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationMemberInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationMemberInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationMemberInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrganizationTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrganizationLogo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.users.OrganizationMemberInviteResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberInviteResponse} returns this
 */
proto.users.OrganizationMemberInviteResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string organization_title = 2;
 * @return {string}
 */
proto.users.OrganizationMemberInviteResponse.prototype.getOrganizationTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberInviteResponse} returns this
 */
proto.users.OrganizationMemberInviteResponse.prototype.setOrganizationTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string organization_logo = 3;
 * @return {string}
 */
proto.users.OrganizationMemberInviteResponse.prototype.getOrganizationLogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.OrganizationMemberInviteResponse} returns this
 */
proto.users.OrganizationMemberInviteResponse.prototype.setOrganizationLogo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationChecklistTaskState.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationChecklistTaskState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationChecklistTaskState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationChecklistTaskState.toObject = function(includeInstance, msg) {
  var f, obj = {
task: jspb.Message.getFieldWithDefault(msg, 1, 0),
complete: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationChecklistTaskState}
 */
proto.users.OrganizationChecklistTaskState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationChecklistTaskState;
  return proto.users.OrganizationChecklistTaskState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationChecklistTaskState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationChecklistTaskState}
 */
proto.users.OrganizationChecklistTaskState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.users.OrganizationChecklistTask} */ (reader.readEnum());
      msg.setTask(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setComplete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationChecklistTaskState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationChecklistTaskState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationChecklistTaskState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationChecklistTaskState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTask();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getComplete();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional OrganizationChecklistTask task = 1;
 * @return {!proto.users.OrganizationChecklistTask}
 */
proto.users.OrganizationChecklistTaskState.prototype.getTask = function() {
  return /** @type {!proto.users.OrganizationChecklistTask} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.users.OrganizationChecklistTask} value
 * @return {!proto.users.OrganizationChecklistTaskState} returns this
 */
proto.users.OrganizationChecklistTaskState.prototype.setTask = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool complete = 2;
 * @return {boolean}
 */
proto.users.OrganizationChecklistTaskState.prototype.getComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.OrganizationChecklistTaskState} returns this
 */
proto.users.OrganizationChecklistTaskState.prototype.setComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.OrganizationChecklistResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.OrganizationChecklistResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.OrganizationChecklistResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.OrganizationChecklistResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationChecklistResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
complete: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.users.OrganizationChecklistTaskState.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.OrganizationChecklistResponse}
 */
proto.users.OrganizationChecklistResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.OrganizationChecklistResponse;
  return proto.users.OrganizationChecklistResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.OrganizationChecklistResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.OrganizationChecklistResponse}
 */
proto.users.OrganizationChecklistResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setComplete(value);
      break;
    case 2:
      var value = new proto.users.OrganizationChecklistTaskState;
      reader.readMessage(value,proto.users.OrganizationChecklistTaskState.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.OrganizationChecklistResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.OrganizationChecklistResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.OrganizationChecklistResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.OrganizationChecklistResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplete();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.users.OrganizationChecklistTaskState.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool complete = 1;
 * @return {boolean}
 */
proto.users.OrganizationChecklistResponse.prototype.getComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.OrganizationChecklistResponse} returns this
 */
proto.users.OrganizationChecklistResponse.prototype.setComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated OrganizationChecklistTaskState tasks = 2;
 * @return {!Array<!proto.users.OrganizationChecklistTaskState>}
 */
proto.users.OrganizationChecklistResponse.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.users.OrganizationChecklistTaskState>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.OrganizationChecklistTaskState, 2));
};


/**
 * @param {!Array<!proto.users.OrganizationChecklistTaskState>} value
 * @return {!proto.users.OrganizationChecklistResponse} returns this
*/
proto.users.OrganizationChecklistResponse.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.users.OrganizationChecklistTaskState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.OrganizationChecklistTaskState}
 */
proto.users.OrganizationChecklistResponse.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.users.OrganizationChecklistTaskState, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.OrganizationChecklistResponse} returns this
 */
proto.users.OrganizationChecklistResponse.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.AppIntegrationRequest.repeatedFields_ = [4];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.users.AppIntegrationRequest.oneofGroups_ = [[6,7,8,9,10,11]];

/**
 * @enum {number}
 */
proto.users.AppIntegrationRequest.SettingsCase = {
  SETTINGS_NOT_SET: 0,
  AHREF: 6,
  SNOVIO: 7,
  HUNTER: 8,
  ROCKET_REACH: 9,
  SEMRUSH: 10,
  MOZ: 11
};

/**
 * @return {proto.users.AppIntegrationRequest.SettingsCase}
 */
proto.users.AppIntegrationRequest.prototype.getSettingsCase = function() {
  return /** @type {proto.users.AppIntegrationRequest.SettingsCase} */(jspb.Message.computeOneofCase(this, proto.users.AppIntegrationRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.AppIntegrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.AppIntegrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.AppIntegrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.AppIntegrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
currentWorkspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
type: jspb.Message.getFieldWithDefault(msg, 3, 0),
allowedForWorkspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
ahref: (f = msg.getAhref()) && common_pb.AhrefIntegrationSettings.toObject(includeInstance, f),
snovio: (f = msg.getSnovio()) && common_pb.SnovioIntegrationSettings.toObject(includeInstance, f),
hunter: (f = msg.getHunter()) && common_pb.HunterIntegrationSettings.toObject(includeInstance, f),
rocketReach: (f = msg.getRocketReach()) && common_pb.RocketReachIntegrationSettings.toObject(includeInstance, f),
semrush: (f = msg.getSemrush()) && common_pb.SemrushIntegrationSettings.toObject(includeInstance, f),
moz: (f = msg.getMoz()) && common_pb.MozIntegrationSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.AppIntegrationRequest}
 */
proto.users.AppIntegrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.AppIntegrationRequest;
  return proto.users.AppIntegrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.AppIntegrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.AppIntegrationRequest}
 */
proto.users.AppIntegrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.IntegrationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAllowedForWorkspaceIds(values[i]);
      }
      break;
    case 5:
      var value = /** @type {!proto.common.IntegrationStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = new common_pb.AhrefIntegrationSettings;
      reader.readMessage(value,common_pb.AhrefIntegrationSettings.deserializeBinaryFromReader);
      msg.setAhref(value);
      break;
    case 7:
      var value = new common_pb.SnovioIntegrationSettings;
      reader.readMessage(value,common_pb.SnovioIntegrationSettings.deserializeBinaryFromReader);
      msg.setSnovio(value);
      break;
    case 8:
      var value = new common_pb.HunterIntegrationSettings;
      reader.readMessage(value,common_pb.HunterIntegrationSettings.deserializeBinaryFromReader);
      msg.setHunter(value);
      break;
    case 9:
      var value = new common_pb.RocketReachIntegrationSettings;
      reader.readMessage(value,common_pb.RocketReachIntegrationSettings.deserializeBinaryFromReader);
      msg.setRocketReach(value);
      break;
    case 10:
      var value = new common_pb.SemrushIntegrationSettings;
      reader.readMessage(value,common_pb.SemrushIntegrationSettings.deserializeBinaryFromReader);
      msg.setSemrush(value);
      break;
    case 11:
      var value = new common_pb.MozIntegrationSettings;
      reader.readMessage(value,common_pb.MozIntegrationSettings.deserializeBinaryFromReader);
      msg.setMoz(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.AppIntegrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.AppIntegrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.AppIntegrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.AppIntegrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCurrentWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAllowedForWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAhref();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.AhrefIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getSnovio();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.SnovioIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getHunter();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.HunterIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getRocketReach();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.RocketReachIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getSemrush();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.SemrushIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getMoz();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.MozIntegrationSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.AppIntegrationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 current_workspace_id = 2;
 * @return {number}
 */
proto.users.AppIntegrationRequest.prototype.getCurrentWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.setCurrentWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.IntegrationType type = 3;
 * @return {!proto.common.IntegrationType}
 */
proto.users.AppIntegrationRequest.prototype.getType = function() {
  return /** @type {!proto.common.IntegrationType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.IntegrationType} value
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated int64 allowed_for_workspace_ids = 4;
 * @return {!Array<number>}
 */
proto.users.AppIntegrationRequest.prototype.getAllowedForWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.setAllowedForWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.addAllowedForWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearAllowedForWorkspaceIdsList = function() {
  return this.setAllowedForWorkspaceIdsList([]);
};


/**
 * optional common.IntegrationStatus status = 5;
 * @return {!proto.common.IntegrationStatus}
 */
proto.users.AppIntegrationRequest.prototype.getStatus = function() {
  return /** @type {!proto.common.IntegrationStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.IntegrationStatus} value
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional common.AhrefIntegrationSettings ahref = 6;
 * @return {?proto.common.AhrefIntegrationSettings}
 */
proto.users.AppIntegrationRequest.prototype.getAhref = function() {
  return /** @type{?proto.common.AhrefIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.AhrefIntegrationSettings, 6));
};


/**
 * @param {?proto.common.AhrefIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationRequest} returns this
*/
proto.users.AppIntegrationRequest.prototype.setAhref = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.users.AppIntegrationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearAhref = function() {
  return this.setAhref(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationRequest.prototype.hasAhref = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.SnovioIntegrationSettings snovio = 7;
 * @return {?proto.common.SnovioIntegrationSettings}
 */
proto.users.AppIntegrationRequest.prototype.getSnovio = function() {
  return /** @type{?proto.common.SnovioIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.SnovioIntegrationSettings, 7));
};


/**
 * @param {?proto.common.SnovioIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationRequest} returns this
*/
proto.users.AppIntegrationRequest.prototype.setSnovio = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.users.AppIntegrationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearSnovio = function() {
  return this.setSnovio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationRequest.prototype.hasSnovio = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.HunterIntegrationSettings hunter = 8;
 * @return {?proto.common.HunterIntegrationSettings}
 */
proto.users.AppIntegrationRequest.prototype.getHunter = function() {
  return /** @type{?proto.common.HunterIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.HunterIntegrationSettings, 8));
};


/**
 * @param {?proto.common.HunterIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationRequest} returns this
*/
proto.users.AppIntegrationRequest.prototype.setHunter = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.users.AppIntegrationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearHunter = function() {
  return this.setHunter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationRequest.prototype.hasHunter = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.RocketReachIntegrationSettings rocket_reach = 9;
 * @return {?proto.common.RocketReachIntegrationSettings}
 */
proto.users.AppIntegrationRequest.prototype.getRocketReach = function() {
  return /** @type{?proto.common.RocketReachIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.RocketReachIntegrationSettings, 9));
};


/**
 * @param {?proto.common.RocketReachIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationRequest} returns this
*/
proto.users.AppIntegrationRequest.prototype.setRocketReach = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.users.AppIntegrationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearRocketReach = function() {
  return this.setRocketReach(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationRequest.prototype.hasRocketReach = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.SemrushIntegrationSettings semrush = 10;
 * @return {?proto.common.SemrushIntegrationSettings}
 */
proto.users.AppIntegrationRequest.prototype.getSemrush = function() {
  return /** @type{?proto.common.SemrushIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.SemrushIntegrationSettings, 10));
};


/**
 * @param {?proto.common.SemrushIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationRequest} returns this
*/
proto.users.AppIntegrationRequest.prototype.setSemrush = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.users.AppIntegrationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearSemrush = function() {
  return this.setSemrush(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationRequest.prototype.hasSemrush = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional common.MozIntegrationSettings moz = 11;
 * @return {?proto.common.MozIntegrationSettings}
 */
proto.users.AppIntegrationRequest.prototype.getMoz = function() {
  return /** @type{?proto.common.MozIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.MozIntegrationSettings, 11));
};


/**
 * @param {?proto.common.MozIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationRequest} returns this
*/
proto.users.AppIntegrationRequest.prototype.setMoz = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.users.AppIntegrationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationRequest} returns this
 */
proto.users.AppIntegrationRequest.prototype.clearMoz = function() {
  return this.setMoz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationRequest.prototype.hasMoz = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.AppIntegrationResponse.repeatedFields_ = [9,10];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.users.AppIntegrationResponse.oneofGroups_ = [[11,12,13,14,15,16]];

/**
 * @enum {number}
 */
proto.users.AppIntegrationResponse.SettingsCase = {
  SETTINGS_NOT_SET: 0,
  AHREF: 11,
  SNOVIO: 12,
  HUNTER: 13,
  ROCKET_REACH: 14,
  SEMRUSH: 15,
  MOZ: 16
};

/**
 * @return {proto.users.AppIntegrationResponse.SettingsCase}
 */
proto.users.AppIntegrationResponse.prototype.getSettingsCase = function() {
  return /** @type {proto.users.AppIntegrationResponse.SettingsCase} */(jspb.Message.computeOneofCase(this, proto.users.AppIntegrationResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.AppIntegrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.AppIntegrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.AppIntegrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.AppIntegrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
learnLink: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
connectedAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
connectedByUserName: jspb.Message.getFieldWithDefault(msg, 8, ""),
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    common_pb.Pair.toObject, includeInstance),
ahref: (f = msg.getAhref()) && common_pb.AhrefIntegrationSettings.toObject(includeInstance, f),
snovio: (f = msg.getSnovio()) && common_pb.SnovioIntegrationSettings.toObject(includeInstance, f),
hunter: (f = msg.getHunter()) && common_pb.HunterIntegrationSettings.toObject(includeInstance, f),
rocketReach: (f = msg.getRocketReach()) && common_pb.RocketReachIntegrationSettings.toObject(includeInstance, f),
semrush: (f = msg.getSemrush()) && common_pb.SemrushIntegrationSettings.toObject(includeInstance, f),
moz: (f = msg.getMoz()) && common_pb.MozIntegrationSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.AppIntegrationResponse}
 */
proto.users.AppIntegrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.AppIntegrationResponse;
  return proto.users.AppIntegrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.AppIntegrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.AppIntegrationResponse}
 */
proto.users.AppIntegrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLearnLink(value);
      break;
    case 5:
      var value = /** @type {!proto.common.IntegrationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {!proto.common.IntegrationStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConnectedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectedByUserName(value);
      break;
    case 9:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    case 10:
      var value = new common_pb.Pair;
      reader.readMessage(value,common_pb.Pair.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    case 11:
      var value = new common_pb.AhrefIntegrationSettings;
      reader.readMessage(value,common_pb.AhrefIntegrationSettings.deserializeBinaryFromReader);
      msg.setAhref(value);
      break;
    case 12:
      var value = new common_pb.SnovioIntegrationSettings;
      reader.readMessage(value,common_pb.SnovioIntegrationSettings.deserializeBinaryFromReader);
      msg.setSnovio(value);
      break;
    case 13:
      var value = new common_pb.HunterIntegrationSettings;
      reader.readMessage(value,common_pb.HunterIntegrationSettings.deserializeBinaryFromReader);
      msg.setHunter(value);
      break;
    case 14:
      var value = new common_pb.RocketReachIntegrationSettings;
      reader.readMessage(value,common_pb.RocketReachIntegrationSettings.deserializeBinaryFromReader);
      msg.setRocketReach(value);
      break;
    case 15:
      var value = new common_pb.SemrushIntegrationSettings;
      reader.readMessage(value,common_pb.SemrushIntegrationSettings.deserializeBinaryFromReader);
      msg.setSemrush(value);
      break;
    case 16:
      var value = new common_pb.MozIntegrationSettings;
      reader.readMessage(value,common_pb.MozIntegrationSettings.deserializeBinaryFromReader);
      msg.setMoz(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.AppIntegrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.AppIntegrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.AppIntegrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.AppIntegrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLearnLink();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getConnectedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getConnectedByUserName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      9,
      f
    );
  }
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      common_pb.Pair.serializeBinaryToWriter
    );
  }
  f = message.getAhref();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.AhrefIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getSnovio();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.SnovioIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getHunter();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.HunterIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getRocketReach();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.RocketReachIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getSemrush();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      common_pb.SemrushIntegrationSettings.serializeBinaryToWriter
    );
  }
  f = message.getMoz();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.MozIntegrationSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.AppIntegrationResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.users.AppIntegrationResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.users.AppIntegrationResponse.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string learn_link = 4;
 * @return {string}
 */
proto.users.AppIntegrationResponse.prototype.getLearnLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setLearnLink = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional common.IntegrationType type = 5;
 * @return {!proto.common.IntegrationType}
 */
proto.users.AppIntegrationResponse.prototype.getType = function() {
  return /** @type {!proto.common.IntegrationType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.IntegrationType} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional common.IntegrationStatus status = 6;
 * @return {!proto.common.IntegrationStatus}
 */
proto.users.AppIntegrationResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.IntegrationStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.IntegrationStatus} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int64 connected_at = 7;
 * @return {number}
 */
proto.users.AppIntegrationResponse.prototype.getConnectedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setConnectedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string connected_by_user_name = 8;
 * @return {string}
 */
proto.users.AppIntegrationResponse.prototype.getConnectedByUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setConnectedByUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated int64 workspace_ids = 9;
 * @return {!Array<number>}
 */
proto.users.AppIntegrationResponse.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};


/**
 * repeated common.Pair details = 10;
 * @return {!Array<!proto.common.Pair>}
 */
proto.users.AppIntegrationResponse.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.common.Pair>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Pair, 10));
};


/**
 * @param {!Array<!proto.common.Pair>} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.common.Pair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.Pair}
 */
proto.users.AppIntegrationResponse.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.common.Pair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearDetailsList = function() {
  return this.setDetailsList([]);
};


/**
 * optional common.AhrefIntegrationSettings ahref = 11;
 * @return {?proto.common.AhrefIntegrationSettings}
 */
proto.users.AppIntegrationResponse.prototype.getAhref = function() {
  return /** @type{?proto.common.AhrefIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.AhrefIntegrationSettings, 11));
};


/**
 * @param {?proto.common.AhrefIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setAhref = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.users.AppIntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearAhref = function() {
  return this.setAhref(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationResponse.prototype.hasAhref = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional common.SnovioIntegrationSettings snovio = 12;
 * @return {?proto.common.SnovioIntegrationSettings}
 */
proto.users.AppIntegrationResponse.prototype.getSnovio = function() {
  return /** @type{?proto.common.SnovioIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.SnovioIntegrationSettings, 12));
};


/**
 * @param {?proto.common.SnovioIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setSnovio = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.users.AppIntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearSnovio = function() {
  return this.setSnovio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationResponse.prototype.hasSnovio = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional common.HunterIntegrationSettings hunter = 13;
 * @return {?proto.common.HunterIntegrationSettings}
 */
proto.users.AppIntegrationResponse.prototype.getHunter = function() {
  return /** @type{?proto.common.HunterIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.HunterIntegrationSettings, 13));
};


/**
 * @param {?proto.common.HunterIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setHunter = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.users.AppIntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearHunter = function() {
  return this.setHunter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationResponse.prototype.hasHunter = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional common.RocketReachIntegrationSettings rocket_reach = 14;
 * @return {?proto.common.RocketReachIntegrationSettings}
 */
proto.users.AppIntegrationResponse.prototype.getRocketReach = function() {
  return /** @type{?proto.common.RocketReachIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.RocketReachIntegrationSettings, 14));
};


/**
 * @param {?proto.common.RocketReachIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setRocketReach = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.users.AppIntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearRocketReach = function() {
  return this.setRocketReach(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationResponse.prototype.hasRocketReach = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional common.SemrushIntegrationSettings semrush = 15;
 * @return {?proto.common.SemrushIntegrationSettings}
 */
proto.users.AppIntegrationResponse.prototype.getSemrush = function() {
  return /** @type{?proto.common.SemrushIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.SemrushIntegrationSettings, 15));
};


/**
 * @param {?proto.common.SemrushIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setSemrush = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.users.AppIntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearSemrush = function() {
  return this.setSemrush(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationResponse.prototype.hasSemrush = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional common.MozIntegrationSettings moz = 16;
 * @return {?proto.common.MozIntegrationSettings}
 */
proto.users.AppIntegrationResponse.prototype.getMoz = function() {
  return /** @type{?proto.common.MozIntegrationSettings} */ (
    jspb.Message.getWrapperField(this, common_pb.MozIntegrationSettings, 16));
};


/**
 * @param {?proto.common.MozIntegrationSettings|undefined} value
 * @return {!proto.users.AppIntegrationResponse} returns this
*/
proto.users.AppIntegrationResponse.prototype.setMoz = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.users.AppIntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.AppIntegrationResponse} returns this
 */
proto.users.AppIntegrationResponse.prototype.clearMoz = function() {
  return this.setMoz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.AppIntegrationResponse.prototype.hasMoz = function() {
  return jspb.Message.getField(this, 16) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.UnsubscribeContent.prototype.toObject = function(opt_includeInstance) {
  return proto.users.UnsubscribeContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.UnsubscribeContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UnsubscribeContent.toObject = function(includeInstance, msg) {
  var f, obj = {
content: jspb.Message.getFieldWithDefault(msg, 1, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
realm: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.UnsubscribeContent}
 */
proto.users.UnsubscribeContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.UnsubscribeContent;
  return proto.users.UnsubscribeContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.UnsubscribeContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.UnsubscribeContent}
 */
proto.users.UnsubscribeContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 3:
      var value = /** @type {!proto.common.RealmType} */ (reader.readEnum());
      msg.setRealm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.UnsubscribeContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.UnsubscribeContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.UnsubscribeContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UnsubscribeContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRealm();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string content = 1;
 * @return {string}
 */
proto.users.UnsubscribeContent.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.UnsubscribeContent} returns this
 */
proto.users.UnsubscribeContent.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool enabled = 2;
 * @return {boolean}
 */
proto.users.UnsubscribeContent.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.UnsubscribeContent} returns this
 */
proto.users.UnsubscribeContent.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional common.RealmType realm = 3;
 * @return {!proto.common.RealmType}
 */
proto.users.UnsubscribeContent.prototype.getRealm = function() {
  return /** @type {!proto.common.RealmType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.RealmType} value
 * @return {!proto.users.UnsubscribeContent} returns this
 */
proto.users.UnsubscribeContent.prototype.setRealm = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.TrackingDomainDnsSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.users.TrackingDomainDnsSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.TrackingDomainDnsSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.TrackingDomainDnsSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, ""),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
pb_default: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.TrackingDomainDnsSettings}
 */
proto.users.TrackingDomainDnsSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.TrackingDomainDnsSettings;
  return proto.users.TrackingDomainDnsSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.TrackingDomainDnsSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.TrackingDomainDnsSettings}
 */
proto.users.TrackingDomainDnsSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.TrackingDomainDnsSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.TrackingDomainDnsSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.TrackingDomainDnsSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.TrackingDomainDnsSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDefault();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.users.TrackingDomainDnsSettings.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.TrackingDomainDnsSettings} returns this
 */
proto.users.TrackingDomainDnsSettings.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.users.TrackingDomainDnsSettings.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.TrackingDomainDnsSettings} returns this
 */
proto.users.TrackingDomainDnsSettings.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.users.TrackingDomainDnsSettings.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.TrackingDomainDnsSettings} returns this
 */
proto.users.TrackingDomainDnsSettings.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool default = 4;
 * @return {boolean}
 */
proto.users.TrackingDomainDnsSettings.prototype.getDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.TrackingDomainDnsSettings} returns this
 */
proto.users.TrackingDomainDnsSettings.prototype.setDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.TrackingDomain.prototype.toObject = function(opt_includeInstance) {
  return proto.users.TrackingDomain.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.TrackingDomain} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.TrackingDomain.toObject = function(includeInstance, msg) {
  var f, obj = {
domain: jspb.Message.getFieldWithDefault(msg, 1, ""),
pb_default: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.TrackingDomain}
 */
proto.users.TrackingDomain.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.TrackingDomain;
  return proto.users.TrackingDomain.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.TrackingDomain} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.TrackingDomain}
 */
proto.users.TrackingDomain.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.TrackingDomain.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.TrackingDomain.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.TrackingDomain} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.TrackingDomain.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDefault();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string domain = 1;
 * @return {string}
 */
proto.users.TrackingDomain.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.TrackingDomain} returns this
 */
proto.users.TrackingDomain.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool default = 2;
 * @return {boolean}
 */
proto.users.TrackingDomain.prototype.getDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.TrackingDomain} returns this
 */
proto.users.TrackingDomain.prototype.setDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ReferralLinkData.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ReferralLinkData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ReferralLinkData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ReferralLinkData.toObject = function(includeInstance, msg) {
  var f, obj = {
link: jspb.Message.getFieldWithDefault(msg, 1, ""),
clickedNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
startedTrialNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
paidCustomerNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalNumbersNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
content: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ReferralLinkData}
 */
proto.users.ReferralLinkData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ReferralLinkData;
  return proto.users.ReferralLinkData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ReferralLinkData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ReferralLinkData}
 */
proto.users.ReferralLinkData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClickedNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStartedTrialNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidCustomerNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalNumbersNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ReferralLinkData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ReferralLinkData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ReferralLinkData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ReferralLinkData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClickedNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStartedTrialNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPaidCustomerNumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTotalNumbersNumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string link = 1;
 * @return {string}
 */
proto.users.ReferralLinkData.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.ReferralLinkData} returns this
 */
proto.users.ReferralLinkData.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 clicked_number = 2;
 * @return {number}
 */
proto.users.ReferralLinkData.prototype.getClickedNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ReferralLinkData} returns this
 */
proto.users.ReferralLinkData.prototype.setClickedNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 started_trial_number = 3;
 * @return {number}
 */
proto.users.ReferralLinkData.prototype.getStartedTrialNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ReferralLinkData} returns this
 */
proto.users.ReferralLinkData.prototype.setStartedTrialNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 paid_customer_number = 4;
 * @return {number}
 */
proto.users.ReferralLinkData.prototype.getPaidCustomerNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ReferralLinkData} returns this
 */
proto.users.ReferralLinkData.prototype.setPaidCustomerNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 total_numbers_number = 5;
 * @return {number}
 */
proto.users.ReferralLinkData.prototype.getTotalNumbersNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ReferralLinkData} returns this
 */
proto.users.ReferralLinkData.prototype.setTotalNumbersNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string content = 6;
 * @return {string}
 */
proto.users.ReferralLinkData.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.ReferralLinkData} returns this
 */
proto.users.ReferralLinkData.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceNotificationRequest}
 */
proto.users.WorkspaceNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceNotificationRequest;
  return proto.users.WorkspaceNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceNotificationRequest}
 */
proto.users.WorkspaceNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.users.WorkspaceNotificationRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationRequest} returns this
 */
proto.users.WorkspaceNotificationRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.users.WorkspaceNotificationRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationRequest} returns this
 */
proto.users.WorkspaceNotificationRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.users.WorkspaceNotificationRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationRequest} returns this
 */
proto.users.WorkspaceNotificationRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceNotificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceNotificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceNotificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
viewed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
viewedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
msg: jspb.Message.getFieldWithDefault(msg, 4, ""),
link: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceNotificationResponse}
 */
proto.users.WorkspaceNotificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceNotificationResponse;
  return proto.users.WorkspaceNotificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceNotificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceNotificationResponse}
 */
proto.users.WorkspaceNotificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setViewed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setViewedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceNotificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceNotificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceNotificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getViewed();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getViewedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WorkspaceNotificationResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool viewed = 2;
 * @return {boolean}
 */
proto.users.WorkspaceNotificationResponse.prototype.getViewed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setViewed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int64 viewed_at = 3;
 * @return {number}
 */
proto.users.WorkspaceNotificationResponse.prototype.getViewedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setViewedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string msg = 4;
 * @return {string}
 */
proto.users.WorkspaceNotificationResponse.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string link = 5;
 * @return {string}
 */
proto.users.WorkspaceNotificationResponse.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.users.WorkspaceNotificationResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 total_items = 7;
 * @return {number}
 */
proto.users.WorkspaceNotificationResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationResponse} returns this
 */
proto.users.WorkspaceNotificationResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceNotificationCountersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceNotificationCountersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceNotificationCountersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationCountersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalItems: jspb.Message.getFieldWithDefault(msg, 1, 0),
notViewedItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceNotificationCountersResponse}
 */
proto.users.WorkspaceNotificationCountersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceNotificationCountersResponse;
  return proto.users.WorkspaceNotificationCountersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceNotificationCountersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceNotificationCountersResponse}
 */
proto.users.WorkspaceNotificationCountersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNotViewedItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceNotificationCountersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceNotificationCountersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceNotificationCountersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationCountersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNotViewedItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 total_items = 1;
 * @return {number}
 */
proto.users.WorkspaceNotificationCountersResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationCountersResponse} returns this
 */
proto.users.WorkspaceNotificationCountersResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 not_viewed_items = 2;
 * @return {number}
 */
proto.users.WorkspaceNotificationCountersResponse.prototype.getNotViewedItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationCountersResponse} returns this
 */
proto.users.WorkspaceNotificationCountersResponse.prototype.setNotViewedItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.WorkspaceNotificationChannel.repeatedFields_ = [5];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.users.WorkspaceNotificationChannel.oneofGroups_ = [[6]];

/**
 * @enum {number}
 */
proto.users.WorkspaceNotificationChannel.SettingsCase = {
  SETTINGS_NOT_SET: 0,
  SLACK: 6
};

/**
 * @return {proto.users.WorkspaceNotificationChannel.SettingsCase}
 */
proto.users.WorkspaceNotificationChannel.prototype.getSettingsCase = function() {
  return /** @type {proto.users.WorkspaceNotificationChannel.SettingsCase} */(jspb.Message.computeOneofCase(this, proto.users.WorkspaceNotificationChannel.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceNotificationChannel.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceNotificationChannel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceNotificationChannel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationChannel.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
channel: jspb.Message.getFieldWithDefault(msg, 3, 0),
integration: jspb.Message.getFieldWithDefault(msg, 4, 0),
workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
slack: (f = msg.getSlack()) && proto.users.WorkspaceNotificationChannel.SlackIntegration.toObject(includeInstance, f),
totalItems: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceNotificationChannel}
 */
proto.users.WorkspaceNotificationChannel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceNotificationChannel;
  return proto.users.WorkspaceNotificationChannel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceNotificationChannel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceNotificationChannel}
 */
proto.users.WorkspaceNotificationChannel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {!proto.common.WorkspaceNotificationChannel} */ (reader.readEnum());
      msg.setChannel(value);
      break;
    case 4:
      var value = /** @type {!proto.common.WorkspaceNotificationChannelIntegration} */ (reader.readEnum());
      msg.setIntegration(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addWorkspaceIds(values[i]);
      }
      break;
    case 6:
      var value = new proto.users.WorkspaceNotificationChannel.SlackIntegration;
      reader.readMessage(value,proto.users.WorkspaceNotificationChannel.SlackIntegration.deserializeBinaryFromReader);
      msg.setSlack(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceNotificationChannel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceNotificationChannel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceNotificationChannel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationChannel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIntegration();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      5,
      f
    );
  }
  f = message.getSlack();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.users.WorkspaceNotificationChannel.SlackIntegration.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WorkspaceNotificationChannel.SlackIntegration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WorkspaceNotificationChannel.SlackIntegration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.toObject = function(includeInstance, msg) {
  var f, obj = {
webhookUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WorkspaceNotificationChannel.SlackIntegration}
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WorkspaceNotificationChannel.SlackIntegration;
  return proto.users.WorkspaceNotificationChannel.SlackIntegration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WorkspaceNotificationChannel.SlackIntegration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WorkspaceNotificationChannel.SlackIntegration}
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebhookUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WorkspaceNotificationChannel.SlackIntegration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WorkspaceNotificationChannel.SlackIntegration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebhookUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string webhook_url = 1;
 * @return {string}
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.prototype.getWebhookUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceNotificationChannel.SlackIntegration} returns this
 */
proto.users.WorkspaceNotificationChannel.SlackIntegration.prototype.setWebhookUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WorkspaceNotificationChannel.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.users.WorkspaceNotificationChannel.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.WorkspaceNotificationChannel channel = 3;
 * @return {!proto.common.WorkspaceNotificationChannel}
 */
proto.users.WorkspaceNotificationChannel.prototype.getChannel = function() {
  return /** @type {!proto.common.WorkspaceNotificationChannel} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.WorkspaceNotificationChannel} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.setChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional common.WorkspaceNotificationChannelIntegration integration = 4;
 * @return {!proto.common.WorkspaceNotificationChannelIntegration}
 */
proto.users.WorkspaceNotificationChannel.prototype.getIntegration = function() {
  return /** @type {!proto.common.WorkspaceNotificationChannelIntegration} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.WorkspaceNotificationChannelIntegration} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.setIntegration = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated int64 workspace_ids = 5;
 * @return {!Array<number>}
 */
proto.users.WorkspaceNotificationChannel.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};


/**
 * optional SlackIntegration slack = 6;
 * @return {?proto.users.WorkspaceNotificationChannel.SlackIntegration}
 */
proto.users.WorkspaceNotificationChannel.prototype.getSlack = function() {
  return /** @type{?proto.users.WorkspaceNotificationChannel.SlackIntegration} */ (
    jspb.Message.getWrapperField(this, proto.users.WorkspaceNotificationChannel.SlackIntegration, 6));
};


/**
 * @param {?proto.users.WorkspaceNotificationChannel.SlackIntegration|undefined} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
*/
proto.users.WorkspaceNotificationChannel.prototype.setSlack = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.users.WorkspaceNotificationChannel.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.clearSlack = function() {
  return this.setSlack(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.WorkspaceNotificationChannel.prototype.hasSlack = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int64 total_items = 7;
 * @return {number}
 */
proto.users.WorkspaceNotificationChannel.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WorkspaceNotificationChannel} returns this
 */
proto.users.WorkspaceNotificationChannel.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.ApiKeyView.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ApiKeyView.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ApiKeyView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ApiKeyView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ApiKeyView.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
uid: jspb.Message.getFieldWithDefault(msg, 2, ""),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdByUserId: jspb.Message.getFieldWithDefault(msg, 4, 0),
name: jspb.Message.getFieldWithDefault(msg, 5, ""),
scopesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
allowedIpsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
monthlyCreditLimitCents: (f = msg.getMonthlyCreditLimitCents()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
keyPrefix: jspb.Message.getFieldWithDefault(msg, 9, ""),
keyLast4: jspb.Message.getFieldWithDefault(msg, 10, ""),
pepperVersion: jspb.Message.getFieldWithDefault(msg, 11, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 13, 0),
expiresAt: (f = msg.getExpiresAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
revokedAt: (f = msg.getRevokedAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ApiKeyView}
 */
proto.users.ApiKeyView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ApiKeyView;
  return proto.users.ApiKeyView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ApiKeyView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ApiKeyView}
 */
proto.users.ApiKeyView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedByUserId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.users.ApiKeyScope>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addScopes(values[i]);
      }
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllowedIps(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMonthlyCreditLimitCents(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyPrefix(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyLast4(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPepperVersion(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setExpiresAt(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setRevokedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ApiKeyView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ApiKeyView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ApiKeyView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ApiKeyView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedByUserId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getScopesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getAllowedIpsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getMonthlyCreditLimitCents();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getKeyPrefix();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getKeyLast4();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPepperVersion();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getExpiresAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getRevokedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.ApiKeyView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string uid = 2;
 * @return {string}
 */
proto.users.ApiKeyView.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.users.ApiKeyView.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_by_user_id = 4;
 * @return {number}
 */
proto.users.ApiKeyView.prototype.getCreatedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.users.ApiKeyView.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated ApiKeyScope scopes = 6;
 * @return {!Array<!proto.users.ApiKeyScope>}
 */
proto.users.ApiKeyView.prototype.getScopesList = function() {
  return /** @type {!Array<!proto.users.ApiKeyScope>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.users.ApiKeyScope>} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setScopesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.users.ApiKeyScope} value
 * @param {number=} opt_index
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.addScopes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.clearScopesList = function() {
  return this.setScopesList([]);
};


/**
 * repeated string allowed_ips = 7;
 * @return {!Array<string>}
 */
proto.users.ApiKeyView.prototype.getAllowedIpsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setAllowedIpsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.addAllowedIps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.clearAllowedIpsList = function() {
  return this.setAllowedIpsList([]);
};


/**
 * optional google.protobuf.Int64Value monthly_credit_limit_cents = 8;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.ApiKeyView.prototype.getMonthlyCreditLimitCents = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 8));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.ApiKeyView} returns this
*/
proto.users.ApiKeyView.prototype.setMonthlyCreditLimitCents = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.clearMonthlyCreditLimitCents = function() {
  return this.setMonthlyCreditLimitCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.ApiKeyView.prototype.hasMonthlyCreditLimitCents = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string key_prefix = 9;
 * @return {string}
 */
proto.users.ApiKeyView.prototype.getKeyPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setKeyPrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string key_last4 = 10;
 * @return {string}
 */
proto.users.ApiKeyView.prototype.getKeyLast4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setKeyLast4 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 pepper_version = 11;
 * @return {number}
 */
proto.users.ApiKeyView.prototype.getPepperVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setPepperVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 created_at = 12;
 * @return {number}
 */
proto.users.ApiKeyView.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 updated_at = 13;
 * @return {number}
 */
proto.users.ApiKeyView.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional google.protobuf.Int64Value expires_at = 14;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.ApiKeyView.prototype.getExpiresAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 14));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.ApiKeyView} returns this
*/
proto.users.ApiKeyView.prototype.setExpiresAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.clearExpiresAt = function() {
  return this.setExpiresAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.ApiKeyView.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Int64Value revoked_at = 15;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.ApiKeyView.prototype.getRevokedAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 15));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.ApiKeyView} returns this
*/
proto.users.ApiKeyView.prototype.setRevokedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.ApiKeyView} returns this
 */
proto.users.ApiKeyView.prototype.clearRevokedAt = function() {
  return this.setRevokedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.ApiKeyView.prototype.hasRevokedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.CreateApiKeyRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.CreateApiKeyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.CreateApiKeyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.CreateApiKeyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateApiKeyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
scopesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
allowedIpsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
monthlyCreditLimitCents: (f = msg.getMonthlyCreditLimitCents()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
expiresAt: (f = msg.getExpiresAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.CreateApiKeyRequest}
 */
proto.users.CreateApiKeyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.CreateApiKeyRequest;
  return proto.users.CreateApiKeyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.CreateApiKeyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.CreateApiKeyRequest}
 */
proto.users.CreateApiKeyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.users.ApiKeyScope>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addScopes(values[i]);
      }
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllowedIps(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMonthlyCreditLimitCents(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.CreateApiKeyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.CreateApiKeyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.CreateApiKeyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateApiKeyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScopesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getAllowedIpsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getMonthlyCreditLimitCents();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getExpiresAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.users.CreateApiKeyRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.users.CreateApiKeyRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ApiKeyScope scopes = 3;
 * @return {!Array<!proto.users.ApiKeyScope>}
 */
proto.users.CreateApiKeyRequest.prototype.getScopesList = function() {
  return /** @type {!Array<!proto.users.ApiKeyScope>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.users.ApiKeyScope>} value
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.setScopesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.users.ApiKeyScope} value
 * @param {number=} opt_index
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.addScopes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.clearScopesList = function() {
  return this.setScopesList([]);
};


/**
 * repeated string allowed_ips = 4;
 * @return {!Array<string>}
 */
proto.users.CreateApiKeyRequest.prototype.getAllowedIpsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.setAllowedIpsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.addAllowedIps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.clearAllowedIpsList = function() {
  return this.setAllowedIpsList([]);
};


/**
 * optional google.protobuf.Int64Value monthly_credit_limit_cents = 5;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.CreateApiKeyRequest.prototype.getMonthlyCreditLimitCents = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.CreateApiKeyRequest} returns this
*/
proto.users.CreateApiKeyRequest.prototype.setMonthlyCreditLimitCents = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.clearMonthlyCreditLimitCents = function() {
  return this.setMonthlyCreditLimitCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.CreateApiKeyRequest.prototype.hasMonthlyCreditLimitCents = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Int64Value expires_at = 6;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.CreateApiKeyRequest.prototype.getExpiresAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.CreateApiKeyRequest} returns this
*/
proto.users.CreateApiKeyRequest.prototype.setExpiresAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.CreateApiKeyRequest} returns this
 */
proto.users.CreateApiKeyRequest.prototype.clearExpiresAt = function() {
  return this.setExpiresAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.CreateApiKeyRequest.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.CreateApiKeyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.CreateApiKeyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.CreateApiKeyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateApiKeyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
key: (f = msg.getKey()) && proto.users.ApiKeyView.toObject(includeInstance, f),
rawKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.CreateApiKeyResponse}
 */
proto.users.CreateApiKeyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.CreateApiKeyResponse;
  return proto.users.CreateApiKeyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.CreateApiKeyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.CreateApiKeyResponse}
 */
proto.users.CreateApiKeyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.ApiKeyView;
      reader.readMessage(value,proto.users.ApiKeyView.deserializeBinaryFromReader);
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRawKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.CreateApiKeyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.CreateApiKeyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.CreateApiKeyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateApiKeyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.users.ApiKeyView.serializeBinaryToWriter
    );
  }
  f = message.getRawKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ApiKeyView key = 1;
 * @return {?proto.users.ApiKeyView}
 */
proto.users.CreateApiKeyResponse.prototype.getKey = function() {
  return /** @type{?proto.users.ApiKeyView} */ (
    jspb.Message.getWrapperField(this, proto.users.ApiKeyView, 1));
};


/**
 * @param {?proto.users.ApiKeyView|undefined} value
 * @return {!proto.users.CreateApiKeyResponse} returns this
*/
proto.users.CreateApiKeyResponse.prototype.setKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.CreateApiKeyResponse} returns this
 */
proto.users.CreateApiKeyResponse.prototype.clearKey = function() {
  return this.setKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.CreateApiKeyResponse.prototype.hasKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string raw_key = 2;
 * @return {string}
 */
proto.users.CreateApiKeyResponse.prototype.getRawKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.CreateApiKeyResponse} returns this
 */
proto.users.CreateApiKeyResponse.prototype.setRawKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListApiKeysRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListApiKeysRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListApiKeysRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeysRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListApiKeysRequest}
 */
proto.users.ListApiKeysRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListApiKeysRequest;
  return proto.users.ListApiKeysRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListApiKeysRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListApiKeysRequest}
 */
proto.users.ListApiKeysRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListApiKeysRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListApiKeysRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListApiKeysRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeysRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.users.ListApiKeysRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeysRequest} returns this
 */
proto.users.ListApiKeysRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.users.ListApiKeysRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeysRequest} returns this
 */
proto.users.ListApiKeysRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.users.ListApiKeysRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeysRequest} returns this
 */
proto.users.ListApiKeysRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.ListApiKeysResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListApiKeysResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListApiKeysResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListApiKeysResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeysResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
keysList: jspb.Message.toObjectList(msg.getKeysList(),
    proto.users.ApiKeyView.toObject, includeInstance),
totalItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListApiKeysResponse}
 */
proto.users.ListApiKeysResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListApiKeysResponse;
  return proto.users.ListApiKeysResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListApiKeysResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListApiKeysResponse}
 */
proto.users.ListApiKeysResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.ApiKeyView;
      reader.readMessage(value,proto.users.ApiKeyView.deserializeBinaryFromReader);
      msg.addKeys(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListApiKeysResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListApiKeysResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListApiKeysResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeysResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.users.ApiKeyView.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated ApiKeyView keys = 1;
 * @return {!Array<!proto.users.ApiKeyView>}
 */
proto.users.ListApiKeysResponse.prototype.getKeysList = function() {
  return /** @type{!Array<!proto.users.ApiKeyView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.ApiKeyView, 1));
};


/**
 * @param {!Array<!proto.users.ApiKeyView>} value
 * @return {!proto.users.ListApiKeysResponse} returns this
*/
proto.users.ListApiKeysResponse.prototype.setKeysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.users.ApiKeyView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.ApiKeyView}
 */
proto.users.ListApiKeysResponse.prototype.addKeys = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.users.ApiKeyView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ListApiKeysResponse} returns this
 */
proto.users.ListApiKeysResponse.prototype.clearKeysList = function() {
  return this.setKeysList([]);
};


/**
 * optional int64 total_items = 2;
 * @return {number}
 */
proto.users.ListApiKeysResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeysResponse} returns this
 */
proto.users.ListApiKeysResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.UpdateApiKeyRequest.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.UpdateApiKeyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.UpdateApiKeyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.UpdateApiKeyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UpdateApiKeyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
scopesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
replaceScopes: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
allowedIpsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
clearAllowedIps: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
monthlyCreditLimitCents: (f = msg.getMonthlyCreditLimitCents()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
clearMonthlyLimit: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
expiresAt: (f = msg.getExpiresAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
clearExpiresAt: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.UpdateApiKeyRequest}
 */
proto.users.UpdateApiKeyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.UpdateApiKeyRequest;
  return proto.users.UpdateApiKeyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.UpdateApiKeyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.UpdateApiKeyRequest}
 */
proto.users.UpdateApiKeyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.users.ApiKeyScope>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addScopes(values[i]);
      }
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReplaceScopes(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllowedIps(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearAllowedIps(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMonthlyCreditLimitCents(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearMonthlyLimit(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setExpiresAt(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.UpdateApiKeyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.UpdateApiKeyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.UpdateApiKeyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UpdateApiKeyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getScopesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getReplaceScopes();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAllowedIpsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getClearAllowedIps();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMonthlyCreditLimitCents();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getClearMonthlyLimit();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getExpiresAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getClearExpiresAt();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.UpdateApiKeyRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.users.UpdateApiKeyRequest.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
*/
proto.users.UpdateApiKeyRequest.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ApiKeyScope scopes = 3;
 * @return {!Array<!proto.users.ApiKeyScope>}
 */
proto.users.UpdateApiKeyRequest.prototype.getScopesList = function() {
  return /** @type {!Array<!proto.users.ApiKeyScope>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.users.ApiKeyScope>} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setScopesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.users.ApiKeyScope} value
 * @param {number=} opt_index
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.addScopes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.clearScopesList = function() {
  return this.setScopesList([]);
};


/**
 * optional bool replace_scopes = 4;
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.getReplaceScopes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setReplaceScopes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated string allowed_ips = 5;
 * @return {!Array<string>}
 */
proto.users.UpdateApiKeyRequest.prototype.getAllowedIpsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setAllowedIpsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.addAllowedIps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.clearAllowedIpsList = function() {
  return this.setAllowedIpsList([]);
};


/**
 * optional bool clear_allowed_ips = 6;
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.getClearAllowedIps = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setClearAllowedIps = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.Int64Value monthly_credit_limit_cents = 7;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.UpdateApiKeyRequest.prototype.getMonthlyCreditLimitCents = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 7));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
*/
proto.users.UpdateApiKeyRequest.prototype.setMonthlyCreditLimitCents = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.clearMonthlyCreditLimitCents = function() {
  return this.setMonthlyCreditLimitCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.hasMonthlyCreditLimitCents = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool clear_monthly_limit = 8;
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.getClearMonthlyLimit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setClearMonthlyLimit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.Int64Value expires_at = 9;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.UpdateApiKeyRequest.prototype.getExpiresAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 9));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
*/
proto.users.UpdateApiKeyRequest.prototype.setExpiresAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.clearExpiresAt = function() {
  return this.setExpiresAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool clear_expires_at = 10;
 * @return {boolean}
 */
proto.users.UpdateApiKeyRequest.prototype.getClearExpiresAt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.UpdateApiKeyRequest} returns this
 */
proto.users.UpdateApiKeyRequest.prototype.setClearExpiresAt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.RotateApiKeyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.RotateApiKeyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.RotateApiKeyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateApiKeyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
graceHours: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.RotateApiKeyRequest}
 */
proto.users.RotateApiKeyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.RotateApiKeyRequest;
  return proto.users.RotateApiKeyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.RotateApiKeyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.RotateApiKeyRequest}
 */
proto.users.RotateApiKeyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGraceHours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.RotateApiKeyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.RotateApiKeyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.RotateApiKeyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateApiKeyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getGraceHours();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.RotateApiKeyRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.RotateApiKeyRequest} returns this
 */
proto.users.RotateApiKeyRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 grace_hours = 2;
 * @return {number}
 */
proto.users.RotateApiKeyRequest.prototype.getGraceHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.RotateApiKeyRequest} returns this
 */
proto.users.RotateApiKeyRequest.prototype.setGraceHours = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.RotateApiKeyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.RotateApiKeyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.RotateApiKeyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateApiKeyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
oldKey: (f = msg.getOldKey()) && proto.users.ApiKeyView.toObject(includeInstance, f),
newKey: (f = msg.getNewKey()) && proto.users.ApiKeyView.toObject(includeInstance, f),
rawNewKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.RotateApiKeyResponse}
 */
proto.users.RotateApiKeyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.RotateApiKeyResponse;
  return proto.users.RotateApiKeyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.RotateApiKeyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.RotateApiKeyResponse}
 */
proto.users.RotateApiKeyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.ApiKeyView;
      reader.readMessage(value,proto.users.ApiKeyView.deserializeBinaryFromReader);
      msg.setOldKey(value);
      break;
    case 2:
      var value = new proto.users.ApiKeyView;
      reader.readMessage(value,proto.users.ApiKeyView.deserializeBinaryFromReader);
      msg.setNewKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRawNewKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.RotateApiKeyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.RotateApiKeyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.RotateApiKeyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateApiKeyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOldKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.users.ApiKeyView.serializeBinaryToWriter
    );
  }
  f = message.getNewKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.users.ApiKeyView.serializeBinaryToWriter
    );
  }
  f = message.getRawNewKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ApiKeyView old_key = 1;
 * @return {?proto.users.ApiKeyView}
 */
proto.users.RotateApiKeyResponse.prototype.getOldKey = function() {
  return /** @type{?proto.users.ApiKeyView} */ (
    jspb.Message.getWrapperField(this, proto.users.ApiKeyView, 1));
};


/**
 * @param {?proto.users.ApiKeyView|undefined} value
 * @return {!proto.users.RotateApiKeyResponse} returns this
*/
proto.users.RotateApiKeyResponse.prototype.setOldKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.RotateApiKeyResponse} returns this
 */
proto.users.RotateApiKeyResponse.prototype.clearOldKey = function() {
  return this.setOldKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.RotateApiKeyResponse.prototype.hasOldKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ApiKeyView new_key = 2;
 * @return {?proto.users.ApiKeyView}
 */
proto.users.RotateApiKeyResponse.prototype.getNewKey = function() {
  return /** @type{?proto.users.ApiKeyView} */ (
    jspb.Message.getWrapperField(this, proto.users.ApiKeyView, 2));
};


/**
 * @param {?proto.users.ApiKeyView|undefined} value
 * @return {!proto.users.RotateApiKeyResponse} returns this
*/
proto.users.RotateApiKeyResponse.prototype.setNewKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.RotateApiKeyResponse} returns this
 */
proto.users.RotateApiKeyResponse.prototype.clearNewKey = function() {
  return this.setNewKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.RotateApiKeyResponse.prototype.hasNewKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string raw_new_key = 3;
 * @return {string}
 */
proto.users.RotateApiKeyResponse.prototype.getRawNewKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.RotateApiKeyResponse} returns this
 */
proto.users.RotateApiKeyResponse.prototype.setRawNewKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ApiKeyAuditEntryView.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ApiKeyAuditEntryView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ApiKeyAuditEntryView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ApiKeyAuditEntryView.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
apiKeyId: jspb.Message.getFieldWithDefault(msg, 2, 0),
action: jspb.Message.getFieldWithDefault(msg, 3, 0),
actorUserId: (f = msg.getActorUserId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
metadataJson: (f = msg.getMetadataJson()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ApiKeyAuditEntryView}
 */
proto.users.ApiKeyAuditEntryView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ApiKeyAuditEntryView;
  return proto.users.ApiKeyAuditEntryView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ApiKeyAuditEntryView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ApiKeyAuditEntryView}
 */
proto.users.ApiKeyAuditEntryView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApiKeyId(value);
      break;
    case 3:
      var value = /** @type {!proto.users.ApiKeyAuditAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setActorUserId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMetadataJson(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ApiKeyAuditEntryView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ApiKeyAuditEntryView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ApiKeyAuditEntryView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ApiKeyAuditEntryView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getApiKeyId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getActorUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMetadataJson();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.ApiKeyAuditEntryView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
 */
proto.users.ApiKeyAuditEntryView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 api_key_id = 2;
 * @return {number}
 */
proto.users.ApiKeyAuditEntryView.prototype.getApiKeyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
 */
proto.users.ApiKeyAuditEntryView.prototype.setApiKeyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ApiKeyAuditAction action = 3;
 * @return {!proto.users.ApiKeyAuditAction}
 */
proto.users.ApiKeyAuditEntryView.prototype.getAction = function() {
  return /** @type {!proto.users.ApiKeyAuditAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.users.ApiKeyAuditAction} value
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
 */
proto.users.ApiKeyAuditEntryView.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Int64Value actor_user_id = 4;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.ApiKeyAuditEntryView.prototype.getActorUserId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
*/
proto.users.ApiKeyAuditEntryView.prototype.setActorUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
 */
proto.users.ApiKeyAuditEntryView.prototype.clearActorUserId = function() {
  return this.setActorUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.ApiKeyAuditEntryView.prototype.hasActorUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue metadata_json = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.users.ApiKeyAuditEntryView.prototype.getMetadataJson = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
*/
proto.users.ApiKeyAuditEntryView.prototype.setMetadataJson = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
 */
proto.users.ApiKeyAuditEntryView.prototype.clearMetadataJson = function() {
  return this.setMetadataJson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.ApiKeyAuditEntryView.prototype.hasMetadataJson = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.users.ApiKeyAuditEntryView.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ApiKeyAuditEntryView} returns this
 */
proto.users.ApiKeyAuditEntryView.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListApiKeyAuditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListApiKeyAuditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListApiKeyAuditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeyAuditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
apiKeyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListApiKeyAuditRequest}
 */
proto.users.ListApiKeyAuditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListApiKeyAuditRequest;
  return proto.users.ListApiKeyAuditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListApiKeyAuditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListApiKeyAuditRequest}
 */
proto.users.ListApiKeyAuditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApiKeyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListApiKeyAuditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListApiKeyAuditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListApiKeyAuditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeyAuditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiKeyId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 api_key_id = 1;
 * @return {number}
 */
proto.users.ListApiKeyAuditRequest.prototype.getApiKeyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeyAuditRequest} returns this
 */
proto.users.ListApiKeyAuditRequest.prototype.setApiKeyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.users.ListApiKeyAuditRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeyAuditRequest} returns this
 */
proto.users.ListApiKeyAuditRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.users.ListApiKeyAuditRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeyAuditRequest} returns this
 */
proto.users.ListApiKeyAuditRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.ListApiKeyAuditResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListApiKeyAuditResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListApiKeyAuditResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListApiKeyAuditResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeyAuditResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.users.ApiKeyAuditEntryView.toObject, includeInstance),
totalItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListApiKeyAuditResponse}
 */
proto.users.ListApiKeyAuditResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListApiKeyAuditResponse;
  return proto.users.ListApiKeyAuditResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListApiKeyAuditResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListApiKeyAuditResponse}
 */
proto.users.ListApiKeyAuditResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.ApiKeyAuditEntryView;
      reader.readMessage(value,proto.users.ApiKeyAuditEntryView.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListApiKeyAuditResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListApiKeyAuditResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListApiKeyAuditResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListApiKeyAuditResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.users.ApiKeyAuditEntryView.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated ApiKeyAuditEntryView entries = 1;
 * @return {!Array<!proto.users.ApiKeyAuditEntryView>}
 */
proto.users.ListApiKeyAuditResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.users.ApiKeyAuditEntryView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.ApiKeyAuditEntryView, 1));
};


/**
 * @param {!Array<!proto.users.ApiKeyAuditEntryView>} value
 * @return {!proto.users.ListApiKeyAuditResponse} returns this
*/
proto.users.ListApiKeyAuditResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.users.ApiKeyAuditEntryView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.ApiKeyAuditEntryView}
 */
proto.users.ListApiKeyAuditResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.users.ApiKeyAuditEntryView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ListApiKeyAuditResponse} returns this
 */
proto.users.ListApiKeyAuditResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * optional int64 total_items = 2;
 * @return {number}
 */
proto.users.ListApiKeyAuditResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListApiKeyAuditResponse} returns this
 */
proto.users.ListApiKeyAuditResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.WebhookEndpointView.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WebhookEndpointView.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WebhookEndpointView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WebhookEndpointView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WebhookEndpointView.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
uid: jspb.Message.getFieldWithDefault(msg, 2, ""),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdByUserId: jspb.Message.getFieldWithDefault(msg, 4, 0),
name: jspb.Message.getFieldWithDefault(msg, 5, ""),
url: jspb.Message.getFieldWithDefault(msg, 6, ""),
subscribedEventsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
status: jspb.Message.getFieldWithDefault(msg, 8, 0),
secretPrefix: jspb.Message.getFieldWithDefault(msg, 9, ""),
secretLast4: jspb.Message.getFieldWithDefault(msg, 10, ""),
encryptionKeyVersion: jspb.Message.getFieldWithDefault(msg, 11, 0),
consecutiveFailures: jspb.Message.getFieldWithDefault(msg, 12, 0),
lastSuccessAt: (f = msg.getLastSuccessAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
lastFailureAt: (f = msg.getLastFailureAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 15, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 16, 0),
disabledAt: (f = msg.getDisabledAt()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WebhookEndpointView}
 */
proto.users.WebhookEndpointView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WebhookEndpointView;
  return proto.users.WebhookEndpointView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WebhookEndpointView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WebhookEndpointView}
 */
proto.users.WebhookEndpointView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedByUserId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.users.WebhookEventType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSubscribedEvents(values[i]);
      }
      break;
    case 8:
      var value = /** @type {!proto.users.WebhookEndpointStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretPrefix(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretLast4(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEncryptionKeyVersion(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConsecutiveFailures(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setLastSuccessAt(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setLastFailureAt(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setDisabledAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WebhookEndpointView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WebhookEndpointView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WebhookEndpointView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WebhookEndpointView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedByUserId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSubscribedEventsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSecretPrefix();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecretLast4();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEncryptionKeyVersion();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getConsecutiveFailures();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getLastSuccessAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getLastFailureAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getDisabledAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string uid = 2;
 * @return {string}
 */
proto.users.WebhookEndpointView.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_by_user_id = 4;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getCreatedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.users.WebhookEndpointView.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string url = 6;
 * @return {string}
 */
proto.users.WebhookEndpointView.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated WebhookEventType subscribed_events = 7;
 * @return {!Array<!proto.users.WebhookEventType>}
 */
proto.users.WebhookEndpointView.prototype.getSubscribedEventsList = function() {
  return /** @type {!Array<!proto.users.WebhookEventType>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.users.WebhookEventType>} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setSubscribedEventsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.users.WebhookEventType} value
 * @param {number=} opt_index
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.addSubscribedEvents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.clearSubscribedEventsList = function() {
  return this.setSubscribedEventsList([]);
};


/**
 * optional WebhookEndpointStatus status = 8;
 * @return {!proto.users.WebhookEndpointStatus}
 */
proto.users.WebhookEndpointView.prototype.getStatus = function() {
  return /** @type {!proto.users.WebhookEndpointStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.users.WebhookEndpointStatus} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string secret_prefix = 9;
 * @return {string}
 */
proto.users.WebhookEndpointView.prototype.getSecretPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setSecretPrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string secret_last4 = 10;
 * @return {string}
 */
proto.users.WebhookEndpointView.prototype.getSecretLast4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setSecretLast4 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 encryption_key_version = 11;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getEncryptionKeyVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setEncryptionKeyVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 consecutive_failures = 12;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getConsecutiveFailures = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setConsecutiveFailures = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional google.protobuf.Int64Value last_success_at = 13;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.WebhookEndpointView.prototype.getLastSuccessAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 13));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.WebhookEndpointView} returns this
*/
proto.users.WebhookEndpointView.prototype.setLastSuccessAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.clearLastSuccessAt = function() {
  return this.setLastSuccessAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.WebhookEndpointView.prototype.hasLastSuccessAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Int64Value last_failure_at = 14;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.WebhookEndpointView.prototype.getLastFailureAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 14));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.WebhookEndpointView} returns this
*/
proto.users.WebhookEndpointView.prototype.setLastFailureAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.clearLastFailureAt = function() {
  return this.setLastFailureAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.WebhookEndpointView.prototype.hasLastFailureAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional int64 created_at = 15;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 updated_at = 16;
 * @return {number}
 */
proto.users.WebhookEndpointView.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional google.protobuf.Int64Value disabled_at = 17;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.WebhookEndpointView.prototype.getDisabledAt = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 17));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.WebhookEndpointView} returns this
*/
proto.users.WebhookEndpointView.prototype.setDisabledAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.WebhookEndpointView} returns this
 */
proto.users.WebhookEndpointView.prototype.clearDisabledAt = function() {
  return this.setDisabledAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.WebhookEndpointView.prototype.hasDisabledAt = function() {
  return jspb.Message.getField(this, 17) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.CreateWebhookEndpointRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.CreateWebhookEndpointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.CreateWebhookEndpointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.CreateWebhookEndpointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateWebhookEndpointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
url: jspb.Message.getFieldWithDefault(msg, 3, ""),
subscribedEventsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.CreateWebhookEndpointRequest}
 */
proto.users.CreateWebhookEndpointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.CreateWebhookEndpointRequest;
  return proto.users.CreateWebhookEndpointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.CreateWebhookEndpointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.CreateWebhookEndpointRequest}
 */
proto.users.CreateWebhookEndpointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.users.WebhookEventType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSubscribedEvents(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.CreateWebhookEndpointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.CreateWebhookEndpointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.CreateWebhookEndpointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateWebhookEndpointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscribedEventsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.users.CreateWebhookEndpointRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.CreateWebhookEndpointRequest} returns this
 */
proto.users.CreateWebhookEndpointRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.users.CreateWebhookEndpointRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.CreateWebhookEndpointRequest} returns this
 */
proto.users.CreateWebhookEndpointRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.users.CreateWebhookEndpointRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.CreateWebhookEndpointRequest} returns this
 */
proto.users.CreateWebhookEndpointRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated WebhookEventType subscribed_events = 4;
 * @return {!Array<!proto.users.WebhookEventType>}
 */
proto.users.CreateWebhookEndpointRequest.prototype.getSubscribedEventsList = function() {
  return /** @type {!Array<!proto.users.WebhookEventType>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.users.WebhookEventType>} value
 * @return {!proto.users.CreateWebhookEndpointRequest} returns this
 */
proto.users.CreateWebhookEndpointRequest.prototype.setSubscribedEventsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.users.WebhookEventType} value
 * @param {number=} opt_index
 * @return {!proto.users.CreateWebhookEndpointRequest} returns this
 */
proto.users.CreateWebhookEndpointRequest.prototype.addSubscribedEvents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.CreateWebhookEndpointRequest} returns this
 */
proto.users.CreateWebhookEndpointRequest.prototype.clearSubscribedEventsList = function() {
  return this.setSubscribedEventsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.CreateWebhookEndpointResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.CreateWebhookEndpointResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.CreateWebhookEndpointResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateWebhookEndpointResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
endpoint: (f = msg.getEndpoint()) && proto.users.WebhookEndpointView.toObject(includeInstance, f),
secret: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.CreateWebhookEndpointResponse}
 */
proto.users.CreateWebhookEndpointResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.CreateWebhookEndpointResponse;
  return proto.users.CreateWebhookEndpointResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.CreateWebhookEndpointResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.CreateWebhookEndpointResponse}
 */
proto.users.CreateWebhookEndpointResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.WebhookEndpointView;
      reader.readMessage(value,proto.users.WebhookEndpointView.deserializeBinaryFromReader);
      msg.setEndpoint(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.CreateWebhookEndpointResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.CreateWebhookEndpointResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.CreateWebhookEndpointResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.CreateWebhookEndpointResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpoint();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.users.WebhookEndpointView.serializeBinaryToWriter
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional WebhookEndpointView endpoint = 1;
 * @return {?proto.users.WebhookEndpointView}
 */
proto.users.CreateWebhookEndpointResponse.prototype.getEndpoint = function() {
  return /** @type{?proto.users.WebhookEndpointView} */ (
    jspb.Message.getWrapperField(this, proto.users.WebhookEndpointView, 1));
};


/**
 * @param {?proto.users.WebhookEndpointView|undefined} value
 * @return {!proto.users.CreateWebhookEndpointResponse} returns this
*/
proto.users.CreateWebhookEndpointResponse.prototype.setEndpoint = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.CreateWebhookEndpointResponse} returns this
 */
proto.users.CreateWebhookEndpointResponse.prototype.clearEndpoint = function() {
  return this.setEndpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.CreateWebhookEndpointResponse.prototype.hasEndpoint = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string secret = 2;
 * @return {string}
 */
proto.users.CreateWebhookEndpointResponse.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.CreateWebhookEndpointResponse} returns this
 */
proto.users.CreateWebhookEndpointResponse.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListWebhookEndpointsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListWebhookEndpointsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListWebhookEndpointsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListWebhookEndpointsRequest}
 */
proto.users.ListWebhookEndpointsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListWebhookEndpointsRequest;
  return proto.users.ListWebhookEndpointsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListWebhookEndpointsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListWebhookEndpointsRequest}
 */
proto.users.ListWebhookEndpointsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListWebhookEndpointsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListWebhookEndpointsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListWebhookEndpointsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.users.ListWebhookEndpointsRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointsRequest} returns this
 */
proto.users.ListWebhookEndpointsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.users.ListWebhookEndpointsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointsRequest} returns this
 */
proto.users.ListWebhookEndpointsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.users.ListWebhookEndpointsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointsRequest} returns this
 */
proto.users.ListWebhookEndpointsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.ListWebhookEndpointsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListWebhookEndpointsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListWebhookEndpointsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListWebhookEndpointsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
endpointsList: jspb.Message.toObjectList(msg.getEndpointsList(),
    proto.users.WebhookEndpointView.toObject, includeInstance),
totalItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListWebhookEndpointsResponse}
 */
proto.users.ListWebhookEndpointsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListWebhookEndpointsResponse;
  return proto.users.ListWebhookEndpointsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListWebhookEndpointsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListWebhookEndpointsResponse}
 */
proto.users.ListWebhookEndpointsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.WebhookEndpointView;
      reader.readMessage(value,proto.users.WebhookEndpointView.deserializeBinaryFromReader);
      msg.addEndpoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListWebhookEndpointsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListWebhookEndpointsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListWebhookEndpointsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.users.WebhookEndpointView.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated WebhookEndpointView endpoints = 1;
 * @return {!Array<!proto.users.WebhookEndpointView>}
 */
proto.users.ListWebhookEndpointsResponse.prototype.getEndpointsList = function() {
  return /** @type{!Array<!proto.users.WebhookEndpointView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.WebhookEndpointView, 1));
};


/**
 * @param {!Array<!proto.users.WebhookEndpointView>} value
 * @return {!proto.users.ListWebhookEndpointsResponse} returns this
*/
proto.users.ListWebhookEndpointsResponse.prototype.setEndpointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.users.WebhookEndpointView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.WebhookEndpointView}
 */
proto.users.ListWebhookEndpointsResponse.prototype.addEndpoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.users.WebhookEndpointView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ListWebhookEndpointsResponse} returns this
 */
proto.users.ListWebhookEndpointsResponse.prototype.clearEndpointsList = function() {
  return this.setEndpointsList([]);
};


/**
 * optional int64 total_items = 2;
 * @return {number}
 */
proto.users.ListWebhookEndpointsResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointsResponse} returns this
 */
proto.users.ListWebhookEndpointsResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.UpdateWebhookEndpointRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.UpdateWebhookEndpointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.UpdateWebhookEndpointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UpdateWebhookEndpointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
url: (f = msg.getUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
subscribedEventsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
replaceEvents: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.UpdateWebhookEndpointRequest}
 */
proto.users.UpdateWebhookEndpointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.UpdateWebhookEndpointRequest;
  return proto.users.UpdateWebhookEndpointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.UpdateWebhookEndpointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.UpdateWebhookEndpointRequest}
 */
proto.users.UpdateWebhookEndpointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUrl(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.users.WebhookEventType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSubscribedEvents(values[i]);
      }
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReplaceEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.UpdateWebhookEndpointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.UpdateWebhookEndpointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.UpdateWebhookEndpointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUrl();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSubscribedEventsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
  f = message.getReplaceEvents();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
*/
proto.users.UpdateWebhookEndpointRequest.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue url = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.getUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
*/
proto.users.UpdateWebhookEndpointRequest.prototype.setUrl = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.clearUrl = function() {
  return this.setUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.hasUrl = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated WebhookEventType subscribed_events = 4;
 * @return {!Array<!proto.users.WebhookEventType>}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.getSubscribedEventsList = function() {
  return /** @type {!Array<!proto.users.WebhookEventType>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.users.WebhookEventType>} value
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.setSubscribedEventsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.users.WebhookEventType} value
 * @param {number=} opt_index
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.addSubscribedEvents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.clearSubscribedEventsList = function() {
  return this.setSubscribedEventsList([]);
};


/**
 * optional bool replace_events = 5;
 * @return {boolean}
 */
proto.users.UpdateWebhookEndpointRequest.prototype.getReplaceEvents = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.users.UpdateWebhookEndpointRequest} returns this
 */
proto.users.UpdateWebhookEndpointRequest.prototype.setReplaceEvents = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.RotateWebhookSecretRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.RotateWebhookSecretRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.RotateWebhookSecretRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateWebhookSecretRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
graceHours: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.RotateWebhookSecretRequest}
 */
proto.users.RotateWebhookSecretRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.RotateWebhookSecretRequest;
  return proto.users.RotateWebhookSecretRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.RotateWebhookSecretRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.RotateWebhookSecretRequest}
 */
proto.users.RotateWebhookSecretRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGraceHours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.RotateWebhookSecretRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.RotateWebhookSecretRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.RotateWebhookSecretRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateWebhookSecretRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getGraceHours();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.RotateWebhookSecretRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.RotateWebhookSecretRequest} returns this
 */
proto.users.RotateWebhookSecretRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 grace_hours = 2;
 * @return {number}
 */
proto.users.RotateWebhookSecretRequest.prototype.getGraceHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.RotateWebhookSecretRequest} returns this
 */
proto.users.RotateWebhookSecretRequest.prototype.setGraceHours = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.RotateWebhookSecretResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.RotateWebhookSecretResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.RotateWebhookSecretResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateWebhookSecretResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
endpoint: (f = msg.getEndpoint()) && proto.users.WebhookEndpointView.toObject(includeInstance, f),
secret: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.RotateWebhookSecretResponse}
 */
proto.users.RotateWebhookSecretResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.RotateWebhookSecretResponse;
  return proto.users.RotateWebhookSecretResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.RotateWebhookSecretResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.RotateWebhookSecretResponse}
 */
proto.users.RotateWebhookSecretResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.WebhookEndpointView;
      reader.readMessage(value,proto.users.WebhookEndpointView.deserializeBinaryFromReader);
      msg.setEndpoint(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.RotateWebhookSecretResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.RotateWebhookSecretResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.RotateWebhookSecretResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.RotateWebhookSecretResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpoint();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.users.WebhookEndpointView.serializeBinaryToWriter
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional WebhookEndpointView endpoint = 1;
 * @return {?proto.users.WebhookEndpointView}
 */
proto.users.RotateWebhookSecretResponse.prototype.getEndpoint = function() {
  return /** @type{?proto.users.WebhookEndpointView} */ (
    jspb.Message.getWrapperField(this, proto.users.WebhookEndpointView, 1));
};


/**
 * @param {?proto.users.WebhookEndpointView|undefined} value
 * @return {!proto.users.RotateWebhookSecretResponse} returns this
*/
proto.users.RotateWebhookSecretResponse.prototype.setEndpoint = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.RotateWebhookSecretResponse} returns this
 */
proto.users.RotateWebhookSecretResponse.prototype.clearEndpoint = function() {
  return this.setEndpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.RotateWebhookSecretResponse.prototype.hasEndpoint = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string secret = 2;
 * @return {string}
 */
proto.users.RotateWebhookSecretResponse.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.users.RotateWebhookSecretResponse} returns this
 */
proto.users.RotateWebhookSecretResponse.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.toObject = function(opt_includeInstance) {
  return proto.users.WebhookEndpointAuditEntryView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.WebhookEndpointAuditEntryView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WebhookEndpointAuditEntryView.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
webhookEndpointId: jspb.Message.getFieldWithDefault(msg, 2, 0),
action: jspb.Message.getFieldWithDefault(msg, 3, 0),
actorUserId: (f = msg.getActorUserId()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
metadataJson: (f = msg.getMetadataJson()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.WebhookEndpointAuditEntryView}
 */
proto.users.WebhookEndpointAuditEntryView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.WebhookEndpointAuditEntryView;
  return proto.users.WebhookEndpointAuditEntryView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.WebhookEndpointAuditEntryView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.WebhookEndpointAuditEntryView}
 */
proto.users.WebhookEndpointAuditEntryView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebhookEndpointId(value);
      break;
    case 3:
      var value = /** @type {!proto.users.WebhookEndpointAuditAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setActorUserId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMetadataJson(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.WebhookEndpointAuditEntryView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.WebhookEndpointAuditEntryView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.WebhookEndpointAuditEntryView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWebhookEndpointId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getActorUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMetadataJson();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
 */
proto.users.WebhookEndpointAuditEntryView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 webhook_endpoint_id = 2;
 * @return {number}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.getWebhookEndpointId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
 */
proto.users.WebhookEndpointAuditEntryView.prototype.setWebhookEndpointId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional WebhookEndpointAuditAction action = 3;
 * @return {!proto.users.WebhookEndpointAuditAction}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.getAction = function() {
  return /** @type {!proto.users.WebhookEndpointAuditAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.users.WebhookEndpointAuditAction} value
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
 */
proto.users.WebhookEndpointAuditEntryView.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Int64Value actor_user_id = 4;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.getActorUserId = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
*/
proto.users.WebhookEndpointAuditEntryView.prototype.setActorUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
 */
proto.users.WebhookEndpointAuditEntryView.prototype.clearActorUserId = function() {
  return this.setActorUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.hasActorUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue metadata_json = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.getMetadataJson = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
*/
proto.users.WebhookEndpointAuditEntryView.prototype.setMetadataJson = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
 */
proto.users.WebhookEndpointAuditEntryView.prototype.clearMetadataJson = function() {
  return this.setMetadataJson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.hasMetadataJson = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.users.WebhookEndpointAuditEntryView.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.WebhookEndpointAuditEntryView} returns this
 */
proto.users.WebhookEndpointAuditEntryView.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListWebhookEndpointAuditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListWebhookEndpointAuditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointAuditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
webhookEndpointId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListWebhookEndpointAuditRequest}
 */
proto.users.ListWebhookEndpointAuditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListWebhookEndpointAuditRequest;
  return proto.users.ListWebhookEndpointAuditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListWebhookEndpointAuditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListWebhookEndpointAuditRequest}
 */
proto.users.ListWebhookEndpointAuditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebhookEndpointId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListWebhookEndpointAuditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListWebhookEndpointAuditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointAuditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebhookEndpointId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 webhook_endpoint_id = 1;
 * @return {number}
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.getWebhookEndpointId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointAuditRequest} returns this
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.setWebhookEndpointId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointAuditRequest} returns this
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointAuditRequest} returns this
 */
proto.users.ListWebhookEndpointAuditRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.users.ListWebhookEndpointAuditResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.users.ListWebhookEndpointAuditResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.users.ListWebhookEndpointAuditResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointAuditResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.users.WebhookEndpointAuditEntryView.toObject, includeInstance),
totalItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.users.ListWebhookEndpointAuditResponse}
 */
proto.users.ListWebhookEndpointAuditResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.users.ListWebhookEndpointAuditResponse;
  return proto.users.ListWebhookEndpointAuditResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.users.ListWebhookEndpointAuditResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.users.ListWebhookEndpointAuditResponse}
 */
proto.users.ListWebhookEndpointAuditResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.users.WebhookEndpointAuditEntryView;
      reader.readMessage(value,proto.users.WebhookEndpointAuditEntryView.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.users.ListWebhookEndpointAuditResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.users.ListWebhookEndpointAuditResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.users.ListWebhookEndpointAuditResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.users.WebhookEndpointAuditEntryView.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated WebhookEndpointAuditEntryView entries = 1;
 * @return {!Array<!proto.users.WebhookEndpointAuditEntryView>}
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.users.WebhookEndpointAuditEntryView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.users.WebhookEndpointAuditEntryView, 1));
};


/**
 * @param {!Array<!proto.users.WebhookEndpointAuditEntryView>} value
 * @return {!proto.users.ListWebhookEndpointAuditResponse} returns this
*/
proto.users.ListWebhookEndpointAuditResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.users.WebhookEndpointAuditEntryView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.users.WebhookEndpointAuditEntryView}
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.users.WebhookEndpointAuditEntryView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.users.ListWebhookEndpointAuditResponse} returns this
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * optional int64 total_items = 2;
 * @return {number}
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.users.ListWebhookEndpointAuditResponse} returns this
 */
proto.users.ListWebhookEndpointAuditResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.users.ScheduleType = {
  DEFAULT: 0,
  CUSTOM: 1
};

/**
 * @enum {number}
 */
proto.users.OrganizationMemberRole = {
  OWNER: 0,
  ADMIN: 1,
  MEMBER: 2
};

/**
 * @enum {number}
 */
proto.users.OrganizationInviteStatus = {
  PENDING: 0,
  EXPIRED: 1
};

/**
 * @enum {number}
 */
proto.users.OrganizationChecklistTask = {
  SCHEDULE_ONBOARDING_SESSION: 0,
  CONNECT_EMAIL_ACCOUNT: 1,
  LAUNCH_CAMPAIGN: 2,
  INVITE_TEAM_MEMBER: 3
};

/**
 * @enum {number}
 */
proto.users.ApiKeyScope = {
  API_KEY_SCOPE_UNSPECIFIED: 0,
  API_KEY_SCOPE_ORDERS_READ: 1,
  API_KEY_SCOPE_ORDERS_WRITE: 2
};

/**
 * @enum {number}
 */
proto.users.ApiKeyAuditAction = {
  API_KEY_AUDIT_ACTION_UNSPECIFIED: 0,
  API_KEY_AUDIT_ACTION_CREATE: 1,
  API_KEY_AUDIT_ACTION_UPDATE: 2,
  API_KEY_AUDIT_ACTION_REVOKE: 3,
  API_KEY_AUDIT_ACTION_ROTATE: 4,
  API_KEY_AUDIT_ACTION_EXPIRE: 5
};

/**
 * @enum {number}
 */
proto.users.WebhookEventType = {
  WEBHOOK_EVENT_TYPE_UNSPECIFIED: 0,
  WEBHOOK_EVENT_TYPE_ORDER_STATUS_CHANGED: 1,
  WEBHOOK_EVENT_TYPE_PLACEMENT_STATUS_CHANGED: 2
};

/**
 * @enum {number}
 */
proto.users.WebhookEndpointStatus = {
  WEBHOOK_ENDPOINT_STATUS_UNSPECIFIED: 0,
  WEBHOOK_ENDPOINT_STATUS_ACTIVE: 1,
  WEBHOOK_ENDPOINT_STATUS_PAUSED: 2,
  WEBHOOK_ENDPOINT_STATUS_DISABLED: 3
};

/**
 * @enum {number}
 */
proto.users.WebhookEndpointAuditAction = {
  WEBHOOK_ENDPOINT_AUDIT_ACTION_UNSPECIFIED: 0,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_CREATE: 1,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_UPDATE: 2,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_ROTATE_SECRET: 3,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_PAUSE: 4,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_RESUME: 5,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_DISABLE: 6,
  WEBHOOK_ENDPOINT_AUDIT_ACTION_AUTO_PAUSE: 7
};

goog.object.extend(exports, proto.users);
